"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9142],{

/***/ 273467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CloseIconGrey; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function CloseIconGrey() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.8346 1.34102L10.6596 0.166016L6.0013 4.82435L1.34297 0.166016L0.167969 1.34102L4.8263 5.99935L0.167969 10.6577L1.34297 11.8327L6.0013 7.17435L10.6596 11.8327L11.8346 10.6577L7.1763 5.99935L11.8346 1.34102Z",
            fill: "#B9B9B9"
        })
    });
}


/***/ }),

/***/ 350541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ DropDownArrowSort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var DropDownArrowSort = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "8",
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.59 7.41016L6 2.83016L1.41 7.41016L0 6.00016L6 0.000156403L12 6.00016L10.59 7.41016Z",
            fill: "black"
        })
    });
};


/***/ }),

/***/ 472933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MobileFilterIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function MobileFilterIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.58098 1.16602H12.4143C12.5343 1.20811 12.6431 1.27711 12.7323 1.36774C12.8216 1.45836 12.8889 1.56821 12.9291 1.68887C12.9693 1.80952 12.9814 1.93778 12.9644 2.06382C12.9474 2.18986 12.9017 2.31033 12.831 2.41602L8.66431 6.99935V12.8327L5.33098 10.3327V6.99935L1.16431 2.41602C1.09356 2.31033 1.04793 2.18986 1.03092 2.06382C1.01392 1.93778 1.02598 1.80952 1.0662 1.68887C1.10642 1.56821 1.17372 1.45836 1.26295 1.36774C1.35218 1.27711 1.46097 1.20811 1.58098 1.16602Z",
            stroke: "black",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 272468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ MobileSortByArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function MobileSortByArrow() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 4.49935L4.83333 1.16602L8.16667 4.49935M4.83333 1.16602V12.8327",
            stroke: "black",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 442466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getProducts; }
/* harmony export */ });
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96031);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(708710);



var getProducts = function(id, type) {
    var pageNo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, storeId = arguments.length > 3 ? arguments[3] : void 0, sortType = arguments.length > 4 ? arguments[4] : void 0, storePrevitem = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true, itemsPerPage = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : _MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_GET_ITEMS_API_PAGE_SIZE */ .CT;
    var staleStoreId = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store.store_id;
    var dispatch = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch;
    var sID = storeId || staleStoreId;
    if (!sID) return;
    return new Promise(function(resolve, reject) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .fetchCatalogItemsByCategoryId */ .Is)({
            store_id: sID,
            category_id: id,
            category_type: type,
            page_no: pageNo,
            sort_type: sortType,
            items_per_page: itemsPerPage,
            storePrevitem: storePrevitem
        }, function(status, isNextPage) {
            return status ? resolve({
                status: status,
                isNextPage: isNextPage
            }) : reject(status);
        }));
    });
};


/***/ }),

/***/ 369142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MiddleBody7_AdvanceCatalogMiddleBody1; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/hooks/useTriggerInitialFilterOptions.js
var useTriggerInitialFilterOptions = __webpack_require__(542249);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/assets/svgExports/MobileSortByArrow.js
var MobileSortByArrow = __webpack_require__(272468);
// EXTERNAL MODULE: ./src/assets/svgExports/MobileFilterIcon.js
var MobileFilterIcon = __webpack_require__(472933);
// EXTERNAL MODULE: ./src/assets/svgExports/DropDownArrowSort.js
var DropDownArrowSort = __webpack_require__(350541);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/AdvanceCatalogMiddleBody.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 0 1rem;\n  max-width: 100rem;\n  margin: 0 auto;\n  @media screen and (max-width: ",
        "px) {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  min-height: 100vh;\n  margin: 32px auto auto auto;\n  width: 100%;\n  max-width: 1500px;\n  @media screen and (max-width: ",
        "px) {\n    margin-top: 22px;\n    justify-content: space-between;\n    min-height: fit-content;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  min-width: ",
        ";\n  width: ",
        ";\n  max-width: ",
        ";\n  height: fit-content;\n  background: white;\n  border-right: 1px solid #eaeaea;\n  position: sticky;\n  top: 75px;\n  transition: 0.5s width;\n  ",
        "\n  @media screen and (max-width : ",
        "px) {\n    width: 100vw;\n    height: 100vh;\n    z-index: 6;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    max-width: unset;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media screen and (max-width: ",
        "px) {\n    min-height: fit-content;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 11px;\n  padding-right: 8px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  display: flex;\n  flex-direction: row;\n  height: 36px;\n  width: fit-content;\n  border: 1px solid #d1d1d1;\n  align-items: center;\n  cursor: pointer;\n  ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    min-width: 50vw;\n    justify-content: center;\n    height: 48px;\n    border-bottom: none;\n    border-left: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  font-size: 14px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 12px;\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column-reverse;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  z-index: 2;\n  justify-content: space-between;\n  @media screen and (max-width: ",
        "px) {\n    position: fixed;\n    background: white;\n    z-index: 6;\n    bottom: 0%;\n    left: 0%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 14px;\n  cursor: pointer;\n\n  > svg {\n    transform-box: fill-box;\n    transform-origin: center;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d1d1d1;\n  position: absolute;\n  transform: translate(0px, 36px);\n  background: white;\n  padding-top: 25px;\n  min-width: 228px;\n  width: 260px;\n  margin-top: 8px;\n  z-index: 9999;\n  ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    bottom: 163%;\n    width: 151vw;\n    padding-top: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  min-width: 158px;\n  margin-bottom: 20px;\n  margin-left: 22px;\n  input[type='radio'] {\n    accent-color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: ",
        ";\n  margin-left: 10px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  min-width: 233px;\n  padding: 9px;\n  border: 1px solid #d1d1d1;\n  ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    min-width: 50vw;\n    height: 48px;\n    border-left: none;\n    border-bottom: none;\n    border-right: none;\n    ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  > svg {\n    transform-box: fill-box;\n    transform-origin: center;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 10px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: 50vh;\n  z-index: 6;\n  transform: translate(50vw, 0px);\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #ededed;\n  margin-bottom: 22px;\n  font-size: 16px;\n  font-weight: 600px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    margin-right: 0px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}


var AdvMiddleBodyContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "AdvMiddleBodyContainer",
    componentId: "sc-cfe1eb65-0"
})(_templateObject(), constants/* MAX_MOBILE_WIDTH */.Cf);
var AdvMiddleBodyWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "AdvMiddleBodyWrapper",
    componentId: "sc-cfe1eb65-1"
})(_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var LeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LeftSection",
    componentId: "sc-cfe1eb65-2"
})(_templateObject2(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) ? "0" : "262px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) ? "0" : "auto";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) ? "0" : "100%";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) && "visibility: ".concat(props === null || props === void 0 ? void 0 : props.visibilty, " ; z-index: -1;");
}, constants/* MAX_MOBILE_WIDTH */.Cf);
var MiddleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MiddleSection",
    componentId: "sc-cfe1eb65-3"
})(_templateObject3(), constants/* MAX_MOBILE_WIDTH */.Cf);
var FilterCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterCtaContainer",
    componentId: "sc-cfe1eb65-4"
})(_templateObject4(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "visibility: hidden" : "visibility : visible";
}, constants/* MAX_MOBILE_WIDTH */.Cf);
var FilterText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterText",
    componentId: "sc-cfe1eb65-5"
})(_templateObject5());
var FilterIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterIconContainer",
    componentId: "sc-cfe1eb65-6"
})(_templateObject6());
var SortByCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByCtaContainer",
    componentId: "sc-cfe1eb65-7"
})(_templateObject7(), constants/* MAX_MOBILE_WIDTH */.Cf);
var SortFilterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortFilterWrapper",
    componentId: "sc-cfe1eb65-8"
})(_templateObject8(), constants/* MAX_MOBILE_WIDTH */.Cf);
var DropDownArrowContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DropDownArrowContainer",
    componentId: "sc-cfe1eb65-9"
})(_templateObject9(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "rotate(0deg)" : "rotate(180deg)";
});
var SortByDropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByDropDownContainer",
    componentId: "sc-cfe1eb65-10"
})(_templateObject10(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.borderRadius) && "border-radius : ".concat(props === null || props === void 0 ? void 0 : props.borderRadius, "px");
}, constants/* MAX_MOBILE_WIDTH */.Cf);
var SortByDropDownListInput = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs(function(props) {
    return {
        type: (props === null || props === void 0 ? void 0 : props.type) ? props === null || props === void 0 ? void 0 : props.type : "radio",
        value: (props === null || props === void 0 ? void 0 : props.value) ? props === null || props === void 0 ? void 0 : props.value : ""
    };
}).withConfig({
    displayName: "SortByDropDownListInput",
    componentId: "sc-cfe1eb65-11"
})(_templateObject11());
var SortByDropDownListElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByDropDownListElement",
    componentId: "sc-cfe1eb65-12"
})(_templateObject12(), function(props) {
    var ref, ref1, ref2;
    return props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color;
});
var SortByDropDownListLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SortByDropDownListLabel",
    componentId: "sc-cfe1eb65-13"
})(_templateObject13(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) ? 600 : 300;
});
var SortByTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByTitle",
    componentId: "sc-cfe1eb65-14"
})(_templateObject14(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.borderRadius) && "border-radius : ".concat(props === null || props === void 0 ? void 0 : props.borderRadius, "px");
}, constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    var ref, ref1, ref2;
    return (props === null || props === void 0 ? void 0 : props.isApplyActive) && "background : ".concat((ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color, "; color: white");
});
var MobileSortIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileSortIcon",
    componentId: "sc-cfe1eb65-15"
})(_templateObject15(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.rotate) ? "rotate(180deg)" : "";
});
var MobileSortIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileSortIconContainer",
    componentId: "sc-cfe1eb65-16"
})(_templateObject16());
var MobileLeftSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileLeftSectionContainer",
    componentId: "sc-cfe1eb65-17"
})(_templateObject17());
var MobileSortHeadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileSortHeadingContainer",
    componentId: "sc-cfe1eb65-18"
})(_templateObject18());
var MobileSortHeadingText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "MobileSortHeadingText",
    componentId: "sc-cfe1eb65-19"
})(_templateObject19());
var MiddleBodyOverflow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MiddleBodyOverflow",
    componentId: "sc-cfe1eb65-20"
})(_templateObject20(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isMobile) ? "auto" : "none";
}, constants/* MAX_MOBILE_WIDTH */.Cf);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/utils/index.js
var utils = __webpack_require__(442466);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCollectionsItems/AllCollectionsItems.styles.ts

function AllCollectionsItems_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    margin-left: 0px;\n    ",
        ";\n  }\n"
    ]);
    AllCollectionsItems_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 27px;\n"
    ]);
    AllCollectionsItems_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #414141;\n  font-size: 17px;\n  font-weight: 500;\n  margin: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    font-size: 12px;\n  }\n"
    ]);
    AllCollectionsItems_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #797979;\n  font-size: 14px;\n  font-weight: 400;\n"
    ]);
    AllCollectionsItems_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > section {\n    margin-top: 24px;\n    display: grid;\n    justify-self: center;\n    justify-items: center;\n    grid-auto-rows: auto;\n\n    @media screen and (min-width: ",
        "px) {\n      grid-template-columns: repeat(3, 1fr);\n      column-gap: 3rem;\n      row-gap: 2rem;\n      justify-self: baseline;\n      justify-items: baseline;\n    }\n    @media screen and (max-width: ",
        "px) {\n      grid-template-columns: repeat(2, 1fr);\n      column-gap: 20px;\n      row-gap: 32px;\n      justify-self: center;\n      justify-items: center;\n    }\n  }\n"
    ]);
    AllCollectionsItems_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var CollectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CollectionWrapper",
    componentId: "sc-1990bbe8-0"
})(AllCollectionsItems_styles_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "76px" : "";
}, constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "visibility: hidden" : "visibility: visible";
});
var CollectionCategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CollectionCategoryWrapper",
    componentId: "sc-1990bbe8-1"
})(AllCollectionsItems_styles_templateObject1());
var CollectionCategoryNameText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CollectionCategoryNameText",
    componentId: "sc-1990bbe8-2"
})(AllCollectionsItems_styles_templateObject2(), function(props) {
    return "0 0 ".concat(props.addBottomSpace ? "27px" : 0, " 0");
}, constants/* MAX_MOBILE_WIDTH */.Cf);
var CollectionNameText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CollectionNameText",
    componentId: "sc-1990bbe8-3"
})(AllCollectionsItems_styles_templateObject3());
var CollectionItemsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CollectionItemsContainer",
    componentId: "sc-1990bbe8-4"
})(AllCollectionsItems_styles_templateObject4(), constants/* MAX_MOBILE_WIDTH */.Cf, constants/* MAX_MOBILE_WIDTH */.Cf);

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCategoriesItems/AllCategoriesItems.styles.ts

function AllCategoriesItems_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AllCategoriesItems_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AllCategoriesItems_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: ",
        "px) {\n    margin-left: 0px;\n    ",
        ";\n  }\n"
    ]);
    AllCategoriesItems_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AllCategoriesItems_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 27px;\n  overflow: hidden;\n"
    ]);
    AllCategoriesItems_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AllCategoriesItems_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AllCategoriesItems_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var CategoriesItemsContainer = (0,styled_components_browser_esm/* default */.ZP)(CollectionItemsContainer).withConfig({
    displayName: "CategoriesItemsContainer",
    componentId: "sc-ebef91c8-0"
})(AllCategoriesItems_styles_templateObject());
var CategoriesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoriesWrapper",
    componentId: "sc-ebef91c8-1"
})(AllCategoriesItems_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "visibility: hidden" : "visibility: visible";
});
var CategoryListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryListWrapper",
    componentId: "sc-ebef91c8-2"
})(AllCategoriesItems_styles_templateObject2());
var CategoryName = (0,styled_components_browser_esm/* default */.ZP)(CollectionCategoryNameText).withConfig({
    displayName: "CategoryName",
    componentId: "sc-ebef91c8-3"
})(AllCategoriesItems_styles_templateObject3());

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(368464);
// EXTERNAL MODULE: ./src/hooks/useOnScreen.js
var useOnScreen = __webpack_require__(497429);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Constants/index.tsx
var Constants = __webpack_require__(26763);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/svg/svgList.tsx

var selectedSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.29395 8.69341L5.90195 12.05L13.0039 5.16663",
            stroke: "#2B74D8",
            "stroke-width": "1.5",
            "stroke-linecap": "square"
        })
    });
};
var minusSvg = function(color) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2 8H14",
            stroke: color,
            "stroke-width": "1.5"
        })
    });
};
var plusSvg = function(color) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.74868 7.25132V2H7.25132V7.25132H2V8.74868H7.25132V14H8.74868V8.74868H14V7.25132H8.74868Z",
            fill: color
        })
    });
};
var crossSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "13",
        viewBox: "0 0 12 13",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            opacity: "0.7",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.89983 3.41985L9.12283 2.64285L6.04269 5.723L2.96255 2.64285L2.18555 3.41985L5.26569 6.5L2.18555 9.58014L2.96255 10.3571L6.04269 7.27699L9.12283 10.3571L9.89983 9.58014L6.81969 6.5L9.89983 3.41985Z",
                fill: "#111C36"
            })
        })
    });
};
var filterIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "16",
                height: "16",
                transform: "translate(0.75 0.400391)",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M11.2502 3.40649C10.0466 3.40649 9.03447 4.27524 8.80103 5.42049H2.25024C1.9741 5.42049 1.75024 5.64592 1.75024 5.92399C1.75024 6.20206 1.9741 6.42749 2.25024 6.42749H8.80103C9.03447 7.57275 10.0466 8.44149 11.2502 8.44149C12.4538 8.44149 13.466 7.57275 13.6995 6.42749H15.2502C15.5264 6.42749 15.7502 6.20206 15.7502 5.92399C15.7502 5.64592 15.5264 5.42049 15.2502 5.42049H13.6995C13.466 4.27524 12.4538 3.40649 11.2502 3.40649ZM11.2502 4.41349C12.0846 4.41349 12.7502 5.08382 12.7502 5.92399C12.7502 6.76417 12.0846 7.43449 11.2502 7.43449C10.4159 7.43449 9.75024 6.76417 9.75024 5.92399C9.75024 5.08382 10.4159 4.41349 11.2502 4.41349Z",
                fill: "#111C36"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M6.25024 8.44153C5.04665 8.44153 4.03447 9.31027 3.80103 10.4555H2.25024C1.9741 10.4555 1.75024 10.681 1.75024 10.959C1.75024 11.2371 1.9741 11.4625 2.25024 11.4625H3.80103C4.03447 12.6078 5.04665 13.4765 6.25024 13.4765C7.45384 13.4765 8.46602 12.6078 8.69946 11.4625H15.2502C15.5264 11.4625 15.7502 11.2371 15.7502 10.959C15.7502 10.681 15.5264 10.4555 15.2502 10.4555H8.69946C8.46602 9.31027 7.45384 8.44153 6.25024 8.44153ZM6.25024 9.44853C7.08458 9.44853 7.75024 10.1189 7.75024 10.959C7.75024 11.7992 7.08458 12.4695 6.25024 12.4695C5.41591 12.4695 4.75024 11.7992 4.75024 10.959C4.75024 10.1189 5.41591 9.44853 6.25024 9.44853Z",
                fill: "#111C36"
            })
        ]
    });
};
var leftArrow = function(fill) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_1537_4746)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16.8999 6.2625L11.3371 12L16.8999 17.7375L15.1874 19.5L7.8999 12L15.1874 4.5L16.8999 6.2625Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1537_4746",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "matrix(0 1 -1 0 24.3999 0)"
                    })
                })
            })
        ]
    });
};
var rightArrow = function(fill) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_1537_4750)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.8999 6.2625L13.4627 12L7.8999 17.7375L9.61245 19.5L16.8999 12L9.61245 4.5L7.8999 6.2625Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1537_4750",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "matrix(0 1 1 0 0.399902 0)"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(826910);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalStyle/globalSettingConstant.tsx
var globalSettingConstant = __webpack_require__(688403);
;// CONCATENATED MODULE: ./src/utils/globalStyleHelper.ts

function globalStyleValue(radius) {
    var index = radius === null || radius === void 0 ? void 0 : radius.indexOf("px");
    var radiusValue = radius === null || radius === void 0 ? void 0 : radius.slice(0, index);
    return radiusValue;
}
function checkForRadiusLimit(style, limit) {
    if (limit) {
        var radius = style === null || style === void 0 ? void 0 : style.borderRadius;
        var radiusValue = globalStyleValue(radius);
        var updatedValue = Number(radiusValue) > limit ? limit : radiusValue;
        return {
            borderRadius: "".concat(updatedValue, "px !important")
        };
    }
    return style;
}
var buttonStyle = function(globalStyle, limit) {
    var limitApplyOnPill = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var buttonStyle = globalStyle.buttons;
    switch(buttonStyle.borderType){
        case globalSettingConstant/* APPEARANCE_CARD_TYPE.SHARP */.oB.SHARP:
            {
                return buttonStyle.style;
            }
        case globalSettingConstant/* APPEARANCE_CARD_TYPE.ROUNDED */.oB.ROUNDED:
            {
                return checkForRadiusLimit(buttonStyle.style, limit);
            }
        case globalSettingConstant/* APPEARANCE_CARD_TYPE.PILL */.oB.PILL:
            {
                if (limitApplyOnPill) {
                    return checkForRadiusLimit(buttonStyle.style, limit);
                } else {
                    return buttonStyle.style;
                }
            }
    }
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Pagination/index.tsx








var PaginationComponent = function(param) {
    var totalPages = param.totalPages, loadSelectedPageData = param.loadSelectedPageData;
    var ref, ref1, ref2;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref3.widgetContextState, pageStyle = _widgetContextState.pageStyle, globalStyle = _widgetContextState.globalStyle;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var store = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            store: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store
        };
    }).store;
    var gridAndPagination = pageStyle.gridAndPagination;
    var pagination_appearance = gridAndPagination.pagination_appearance;
    var boxRadius = buttonStyle(globalStyle, 8, false);
    var borderRadiusVal = globalStyleValue(boxRadius === null || boxRadius === void 0 ? void 0 : boxRadius.borderRadius);
    var themeColor = (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.color) === null || ref === void 0 ? void 0 : ref.themeColor) || (store === null || store === void 0 ? void 0 : (ref1 = store.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color);
    var visibleCount = 5;
    var midIndex = Math.floor(visibleCount / 2);
    var ref4 = (0,react.useState)(1), currentPage = ref4[0], setCurrentPage = ref4[1];
    (0,react.useEffect)(function() {
        setCurrentPage(1);
    }, [
        totalPages
    ]);
    var getVisiblePages = function() {
        var start = Math.max(1, currentPage - midIndex);
        var end = start + visibleCount - 1;
        if (end > totalPages) {
            end = totalPages;
            start = Math.max(1, end - visibleCount + 1);
        }
        return Array.from({
            length: end - start + 1
        }, function(_, i) {
            return start + i;
        });
    };
    var visiblePages = getVisiblePages();
    var goToPage = function(page) {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            loadSelectedPageData(page);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex ".concat(!isMobile ? "tw-items-center tw-justify-between" : "tw-flex-col-reverse tw-items-center tw-justify-center tw-gap-[20px]", " "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-text-[15px] tw-font-normal tw-text-[#667479] ",
                children: "Pages ".concat(currentPage, " of ").concat(totalPages)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return goToPage(currentPage - 1);
                        },
                        className: "".concat(currentPage === 1 ? "tw-opacity-50 tw-pointer-events-none" : "tw-cursor-pointer", " tw-mt-[5px]"),
                        children: pagination_appearance === Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-[12px] tw-font-medium tw-text-newBlack ".concat(currentPage === 1 ? "tw-opacity-50 tw-pointer-events-none" : ""),
                            children: "Previous"
                        }) : leftArrow(currentPage === 1 ? "#BCBCBC" : "#111C36")
                    }),
                    visiblePages.map(function(page) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return goToPage(page);
                            },
                            style: {
                                borderRadius: borderRadiusVal,
                                borderColor: currentPage === page ? themeColor : "#111C361F",
                                background: pagination_appearance === Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE && currentPage === page ? themeColor : "",
                                color: pagination_appearance === Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE && currentPage === page ? "white" : ""
                            },
                            className: "tw-flex tw-items-center tw-justify-center tw-h-[40px] tw-w-[40px]\n             tw-border tw-border-solid \n             tw-text-[14px] tw-font-normal tw-text-newBlack tw-cursor-pointer ".concat(currentPage === page ? " tw-font-bold " : pagination_appearance === Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE ? "tw-border-none" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: page
                            })
                        }, page);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: function() {
                            return goToPage(currentPage + 1);
                        },
                        className: "".concat(currentPage === totalPages ? "tw-opacity-50 tw-pointer-events-none" : "tw-cursor-pointer", " tw-mt-[5px]"),
                        children: [
                            pagination_appearance === Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-text-[12px] tw-font-medium tw-text-newBlack ".concat(currentPage === totalPages ? "tw-opacity-50 tw-pointer-events-none" : ""),
                                children: "Next"
                            }) : rightArrow(currentPage === totalPages ? "#BCBCBC" : "#111C36"),
                            " "
                        ]
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};
/* harmony default export */ var Pagination = (PaginationComponent);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/constant.ts
var COLOUR = "Colour";
var SIZE = "Size";
var CUSTOM = "Custom";
var FILTER_CUSTOM_CLASS = "tw-flex tw-flex-col tw-gap-[12px]";
var COLOR_DIFF_LAYOUT = [
    "layout2",
    "layout3"
];
var FILTER_CUSTOM_CLASS_2 = "tw-flex tw-items-center tw-gap-[16px] tw-flex-wrap";
var HEADING_TYPE_IMAGE = "image";
var IS_TEXT_ON_IMAGE = "on-image";
var PAGINATION = "add-pagination";
var FILTER_OPTIONS_SNF_WIDGET = {
    // Filter options of AdvCatalogMiddleBody ( aka SortAndFilter Widget )
    COLLECTION: "Collections",
    CATEGORIES: "Categories",
    TAGS: "Tags",
    BRANDS: "Brands",
    PRICE_RANGE: "Price Range",
    SIZE: "Size"
};

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/utils.js
var MiddleBody7_utils = __webpack_require__(708710);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCategoriesItems/AllCategoriesItems.tsx






// import LoaderIcon from '@/components/Common/LoaderIcon';













function AllCategoriesItems(props) {
    var getSelectedCategory = function getSelectedCategory() {
        var ref;
        return (ref = (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories))) === null || ref === void 0 ? void 0 : ref.filter(function(data) {
            return Number(data.id) === Number(props === null || props === void 0 ? void 0 : props.selectedId);
        });
    };
    var categoryPageNumber = /**
   * @param {number} categoryId
   * @return {number} page number for api.
   */ function categoryPageNumber(categoryId) {
        var ref, ref1, ref2, ref3;
        return ((ref = categoryPaginationStatus.current[categoryId]) === null || ref === void 0 ? void 0 : (ref3 = ref.pages) === null || ref3 === void 0 ? void 0 : ref3[((ref1 = categoryPaginationStatus.current[categoryId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.length) - 1]) + 1;
    };
    var returnNestedCategoryData = /**
   *
   * @param {number} categoryId
   * @return {object} category data that needs to be rendered.
   */ function returnNestedCategoryData(categoryId) {
        var categoryIdValue = undefined;
        categoryIdValue = catalog_items[categoryId];
        return categoryIdValue;
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var comingFromAdvCatlog = props.comingFromAdvCatlog;
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref.widgetContextState, pageStyle = _widgetContextState.pageStyle, isBuilder = _widgetContextState.isBuilder;
    var ref1 = pageStyle || {}, _gridAndPagination = ref1.gridAndPagination, gridAndPagination = _gridAndPagination === void 0 ? {} : _gridAndPagination;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            catalog_items: state.catalogReducer.catalog_items,
            totalPages: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.totalPages,
            sortType: (ref1 = state.catalogReducer) === null || ref1 === void 0 ? void 0 : ref1.sortType
        };
    }), catalog_items = ref2.catalog_items, totalPages = ref2.totalPages, sortType = ref2.sortType;
    var ref3;
    var ref4 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            storeData: state.storeReducer.store,
            categories: state.catalogReducer.categories,
            productTags: (ref3 = (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.productTags) !== null && ref3 !== void 0 ? ref3 : []
        };
    }), store_id = ref4.storeData.store_id, categories = ref4.categories, productTags = ref4.productTags;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    /**
   * the following data has been kept in useRef for the purpose of
   * synchronous data manipulation
   */ /**
   * categoryPaginationStatus : it holds data for each category if its nextPage
   * is there and array for page number for which the api has been called
   */ var categoryPaginationStatus = (0,react.useRef)({});
    /**
   * categoryPaginationIterator : its an Iterator to change category nextPage To true
   * when the one category is full rendered and we need to render the next category
   */ // const categoryPaginationIterator = useRef(0);
    /**
   * categoryIdArray : contains categoryId's
   */ var categoryIdArray = (0,react.useRef)([]);
    /**
   * loader : used to control pagination api. if one api is called till its
   * execution is not done loader will not change state and critical section of code
   * is not invoked
   */ var loader = (0,react.useRef)({});
    /** for new PLP flow we only show single category at a time. Adding a check here
   *  if it's coming from advance catalog we will render only single category because in new PLP flow 
   *  we replaced all the PLP component with advance catalog component */ var updatedCategoryData = (0,react.useMemo)(function() {
        return comingFromAdvCatlog ? getSelectedCategory() : categories;
    }, [
        props === null || props === void 0 ? void 0 : props.selectedId,
        comingFromAdvCatlog
    ]);
    /**
   * initializing categoryIdArray and categoryPaginationStatus
   */ (0,react.useEffect)(function() {
        var tempCategoryPaginationStatus = {};
        updatedCategoryData && !!(updatedCategoryData === null || updatedCategoryData === void 0 ? void 0 : updatedCategoryData.length) && updatedCategoryData.forEach(function(item, index) {
            var tempStatusObj = {};
            tempStatusObj["isNext"] = index === 0 ? true : false;
            tempStatusObj["pages"] = [
                0
            ];
            tempCategoryPaginationStatus[item.id] = tempStatusObj;
        });
        categoryPaginationStatus.current = tempCategoryPaginationStatus;
        updatedCategoryData && !!(updatedCategoryData === null || updatedCategoryData === void 0 ? void 0 : updatedCategoryData.length) && updatedCategoryData.forEach(function(item) {
            categoryIdArray.current.push(item === null || item === void 0 ? void 0 : item.id);
        });
        return function() {
            dispatch((0,catalog/* resetCatalogsList */.wL)());
        };
    }, [
        updatedCategoryData
    ]);
    var isTag = function(categoryId) {
        return (productTags === null || productTags === void 0 ? void 0 : productTags.length) && productTags.findIndex(function(tag) {
            return tag.id === categoryId;
        }) >= 0;
    };
    function fetchProductsForCategory(categoryId, pageNo) {
        return _fetchProductsForCategory.apply(this, arguments);
    }
    function _fetchProductsForCategory() {
        _fetchProductsForCategory = (0,_async_to_generator/* default */.Z)(function(categoryId, pageNo) {
            var storePrevitem;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        storePrevitem = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                        if (!store_id) return [
                            2
                        ];
                        return [
                            4,
                            (0,utils/* getProducts */.X)(categoryId, isTag(categoryId) ? constants/* CATEGORY_TYPE.TAG */.MI.TAG : constants/* CATEGORY_TYPE.CATEGORY */.MI.CATEGORY, pageNo, store_id, sortType, storePrevitem, (0,MiddleBody7_utils/* getPaginatedItemsPerPage */.vU)(gridAndPagination, isMobile))
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _fetchProductsForCategory.apply(this, arguments);
    }
    function loadMoreDataCategories(categoryId) {
        return _loadMoreDataCategories.apply(this, arguments);
    }
    function _loadMoreDataCategories() {
        _loadMoreDataCategories = /**
   * loads data / is invoked when user Scroll end
   * @param {number} categoryId
   */ (0,_async_to_generator/* default */.Z)(function(categoryId) {
            var ref, ref1, ref2, pageNo, ref3, status, isNextPage, ref4, ref5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageNo = categoryPageNumber(categoryId);
                        if (!(!((ref = loader.current) === null || ref === void 0 ? void 0 : ref[categoryId]) && !((ref1 = categoryPaginationStatus.current[categoryId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.includes(pageNo)) && categoryId)) return [
                            3,
                            2
                        ];
                        loader.current[categoryId] = true;
                        if (!store_id) return [
                            2
                        ];
                        return [
                            4,
                            fetchProductsForCategory(categoryId, pageNo, true)
                        ];
                    case 1:
                        ref3 = _state.sent(), status = ref3.status, isNextPage = ref3.isNextPage;
                        if (status) {
                            ;
                            (ref4 = categoryPaginationStatus.current[categoryId]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.pages) === null || ref5 === void 0 ? void 0 : ref5.push(pageNo);
                            categoryPaginationStatus.current[categoryId]["isNext"] = isNextPage;
                        }
                        _state.label = 2;
                    case 2:
                        loader.current[categoryId] = false;
                        return [
                            2
                        ];
                }
            });
        });
        return _loadMoreDataCategories.apply(this, arguments);
    }
    function loadMorePaginatedData(categoryId, pageNo) {
        return _loadMorePaginatedData.apply(this, arguments);
    }
    function _loadMorePaginatedData() {
        _loadMorePaginatedData = (0,_async_to_generator/* default */.Z)(function(categoryId, pageNo) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchProductsForCategory(categoryId, pageNo, false)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _loadMorePaginatedData.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesWrapper, {
        showFilterDrawer: props === null || props === void 0 ? void 0 : props.showFilterDrawer,
        showSortByDropDown: props === null || props === void 0 ? void 0 : props.showSortByDropDown,
        children: updatedCategoryData === null || updatedCategoryData === void 0 ? void 0 : updatedCategoryData.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection, {
                category: category,
                loadMoreDataCategories: loadMoreDataCategories,
                loadMorePaginatedData: loadMorePaginatedData,
                returnNestedCategoryData: returnNestedCategoryData,
                categoryPaginationStatus: categoryPaginationStatus,
                loader: loader,
                comingFromAdvCatlog: comingFromAdvCatlog,
                catalog_items: catalog_items,
                totalPages: totalPages,
                isBuilder: isBuilder
            }, category.id);
        })
    });
}
/* harmony default export */ var AllCategoriesItems_AllCategoriesItems = (AllCategoriesItems);
var CategorySection = function(param) {
    var category = param.category, loadMoreDataCategories = param.loadMoreDataCategories, loadMorePaginatedData = param.loadMorePaginatedData, returnNestedCategoryData = param.returnNestedCategoryData, categoryPaginationStatus = param.categoryPaginationStatus, loader = param.loader, catalog_items = param.catalog_items, comingFromAdvCatlog = param.comingFromAdvCatlog, totalPages = param.totalPages, isBuilder = param.isBuilder;
    var checkIfNumberedPagination = /**
   * @description Checks whether the pagination type is Numbered pagination ( as compared to the default infinite scroll )
   * @returns boolean
   */ function checkIfNumberedPagination() {
        var ref = gridAndPagination || {}, _pagination_style_desktop = ref.pagination_style_desktop, pagination_style_desktop = _pagination_style_desktop === void 0 ? "" : _pagination_style_desktop, _pagination_style_mobile = ref.pagination_style_mobile, pagination_style_mobile = _pagination_style_mobile === void 0 ? "" : _pagination_style_mobile;
        var style = isMobile ? pagination_style_mobile : pagination_style_desktop;
        return style === PAGINATION;
    };
    var ref, ref1;
    var ref2 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), pageStyle = ref2.widgetContextState.pageStyle;
    var ref3 = pageStyle || {}, _gridAndPagination = ref3.gridAndPagination, gridAndPagination = _gridAndPagination === void 0 ? {} : _gridAndPagination;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref4 = (0,react.useRef)(null);
    var scrollRef = (0,react.useRef)(null);
    var hasLoaded = (0,react.useRef)(false);
    var isVisible = (0,useOnScreen/* default */.Z)(ref4, {
        threshold: 0.1
    });
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var isNumberedPagination = checkIfNumberedPagination();
    (0,react.useEffect)(function() {
        if (!isNumberedPagination && isVisible && !hasLoaded.current && !(catalog_items === null || catalog_items === void 0 ? void 0 : catalog_items[category.id])) {
            loadMoreDataCategories(category.id);
            hasLoaded.current = true;
        }
    }, [
        isVisible,
        catalog_items
    ]);
    (0,react.useEffect)(function() {
        // If the pagination type is not infinite scroll, then fetch the category data for selected category with page number 1
        if (isNumberedPagination) {
            loadMorePaginatedData(category.id, 1);
        }
    }, [
        isNumberedPagination
    ]);
    var scrollToDiv = function() {
        if (isBuilder) {
            var ref;
            scrollRef === null || scrollRef === void 0 ? void 0 : (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behaviour: "smooth",
                block: "start"
            });
        } else {
            var ref1;
            var top = (scrollRef === null || scrollRef === void 0 ? void 0 : (ref1 = scrollRef.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()).top;
            window.scrollTo({
                top: top + window.scrollY - 200,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: scrollRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryListWrapper, {
            ref: ref4,
            children: [
                !comingFromAdvCatlog && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryName, {
                    children: category === null || category === void 0 ? void 0 : category.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoriesItemsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                            productList: returnNestedCategoryData(category === null || category === void 0 ? void 0 : category.id),
                            calculateSelfDimensions: true,
                            renderAdvancedCard: true,
                            oldCardConfigs: {
                                showButton: true,
                                noTagsReadState: "fromLength"
                            },
                            customClass: "tw-mt-[24px]"
                        }),
                        isNumberedPagination ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-my-[50px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                                totalPages: totalPages,
                                loadSelectedPageData: function(pageNo) {
                                    scrollToDiv();
                                    loadMorePaginatedData(category === null || category === void 0 ? void 0 : category.id, pageNo);
                                }
                            })
                        }) : ((ref = categoryPaginationStatus.current[category === null || category === void 0 ? void 0 : category.id]) === null || ref === void 0 ? void 0 : ref.isNext) && !(loader === null || loader === void 0 ? void 0 : (ref1 = loader.current) === null || ref1 === void 0 ? void 0 : ref1[category === null || category === void 0 ? void 0 : category.id]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-w-full tw-justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return loadMoreDataCategories(category === null || category === void 0 ? void 0 : category.id);
                                },
                                style: {
                                    borderColor: themeColor,
                                    color: themeColor
                                },
                                className: "tw-mx-8 tw-mb-34 tw-mt-24 tw-w-[100px] tw-cursor-pointer tw-border tw-border-solid tw-py-12 tw-text-center tw-text-14 tw-font-medium sm:tw-w-full",
                                children: "View More"
                            })
                        })
                    ]
                })
            ]
        }, category === null || category === void 0 ? void 0 : category.id)
    });
};

// EXTERNAL MODULE: ./src/containers/Collections/FlatListV2.tsx
var FlatListV2 = __webpack_require__(698331);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCollectionsItems/AllCollectionsItems.tsx












function AllCollectionsItems(props) {
    var loadMoreData = /**
   * this function fetches collection category items when data
   * needs to be loaded
   * @param {number} category
   * @param {number} collection
   */ function loadMoreData(category, collection) {
        if (isBuilder) return;
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,catalog/* fetchCollectionCatalogItemById */.lA)({
                storeId: storeData.store_id,
                collectionId: collection.id,
                categoryId: category.id
            }));
        }
    };
    var returnNestedCollectionData = /**
   * this function checks collection object for presence of category and its items
   * as it may or may not be there as we call api when we need to show the items
   * @param {number} collectionId
   * @param {number} categoryId
   * @returns {Array}  of items that needs to be rendered in a collection category
   */ function returnNestedCollectionData(collectionId, categoryId) {
        var collectionIdValue = collectionCatalogItems[collectionId];
        var categoryIdValue = undefined;
        if (collectionIdValue) {
            categoryIdValue = collectionIdValue[categoryId];
        }
        return categoryIdValue;
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), isBuilder = ref.widgetContextState.isBuilder;
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections,
            storeData: state.storeReducer.store
        };
    }), collections = ref1.collections, storeData = ref1.storeData;
    var collectionCatalogItems = (0,es/* useSelector */.v9)(function(state) {
        return {
            collectionCatalogItems: state.catalogReducer.collectionCatalogItems
        };
    }).collectionCatalogItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (collections === null || collections === void 0 ? void 0 : collections.length) ? collections.map(function(collection) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionWrapper, {
                showSortByDropDown: props === null || props === void 0 ? void 0 : props.showSortByDropDown,
                showFilterDrawer: props === null || props === void 0 ? void 0 : props.showFilterDrawer,
                children: collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionCategorySection, {
                        category: category,
                        collection: collection,
                        loadMoreData: loadMoreData,
                        returnNestedCollectionData: returnNestedCollectionData,
                        storeData: storeData
                    }, category === null || category === void 0 ? void 0 : category.id);
                })
            }, collection === null || collection === void 0 ? void 0 : collection.id);
        }) : null
    });
}
/* harmony default export */ var AllCollectionsItems_AllCollectionsItems = (AllCollectionsItems);
var CollectionCategorySection = function(param) {
    var category = param.category, collection = param.collection, loadMoreData = param.loadMoreData, storeData = param.storeData, returnNestedCollectionData = param.returnNestedCollectionData;
    var limitProductListItems = function limitProductListItems() {
        return (collectionData === null || collectionData === void 0 ? void 0 : collectionData.length) > 12;
    };
    var routeToCategory = function routeToCategory() {
        var ref;
        window.location.href = (0,routes.getRoute)("".concat(routes.PATH.SHOP, "/").concat(category.name, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
    };
    var ref;
    var router = (0,next_router.useRouter)();
    var collectionData = returnNestedCollectionData(collection.id, category.id);
    var handleLoadMore = function() {
        if (collectionData) return;
        loadMoreData(category, collection);
    };
    var CollectionNameTag = router.asPath.includes("/shop") || router.asPath.includes("/collections") ? CollectionNameText.withComponent("h1") : CollectionNameText;
    var productList = (0,react.useMemo)(function() {
        if (!Array.isArray(collectionData) || !(collectionData === null || collectionData === void 0 ? void 0 : collectionData.length)) return [];
        return collectionData.filter(function(data) {
            var ref;
            return data.is_active === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE && (!(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock) || (data === null || data === void 0 ? void 0 : data.available));
        }).slice(0, 12); // Limit to 12 items
    }, [
        collectionData,
        collectionData === null || collectionData === void 0 ? void 0 : collectionData.length,
        storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatListV2/* default */.Z, {
        loadMoreData: handleLoadMore,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionCategoryWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionCategoryNameText, {
                    addBottomSpace: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionNameTag, {
                            children: "".concat(collection.name, "  /  ")
                        }),
                        category.name
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                            productList: productList,
                            oldCardConfigs: {
                                showButton: true,
                                noTagsReadState: "fromLength"
                            },
                            renderAdvancedCard: true,
                            calculateSelfDimensions: true
                        }),
                        !!limitProductListItems() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-items-center tw-justify-center tw-mt-48",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "tw-cursor-pointer tw-border-none tw-bg-black tw-px-16 tw-py-8 tw-text-white",
                                onClick: routeToCategory,
                                children: "Show More"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.js + 4 modules
var FilterDrawer = __webpack_require__(391612);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(155772);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/utils/getFilteredOptionProducts.js
var getFilteredOptionProducts = __webpack_require__(936051);
;// CONCATENATED MODULE: ./src/assets/svgExports/ItemsNotFound.js

function ItemsNotFound() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "250",
        height: "200",
        viewBox: "0 0 250 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "250",
                height: "200",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M120.5 133C139.002 133 154 118.002 154 99.5C154 80.9985 139.002 66 120.5 66C101.998 66 87 80.9985 87 99.5C87 118.002 101.998 133 120.5 133Z",
                fill: "#F2F2F2",
                stroke: "#828282",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M115.132 125.494C116.891 125.819 118.68 125.987 120.5 126C135.136 126 147 114.136 147 99.5C147 84.8645 135.136 73 120.5 73C116.74 73 113.164 73.7829 109.924 75.1946C104.294 77.6479 99.6816 81.9999 96.896 87.4419C95.0445 91.0589 94 95.1575 94 99.5C94 103.44 94.8599 107.179 96.4021 110.54C97.5032 112.94 98.9521 115.146 100.684 117.096",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M115.132 125.494C116.891 125.819 118.68 125.987 120.5 126C135.136 126 147 114.136 147 99.5C147 84.8645 135.136 73 120.5 73C116.74 73 113.164 73.7829 109.924 75.1946C104.294 77.6479 99.6816 81.9999 96.896 87.4419C95.0445 91.0589 94 95.1575 94 99.5C94 103.44 94.8599 107.179 96.4021 110.54C97.5032 112.94 98.9521 115.146 100.684 117.096",
                stroke: "#828282",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.797 120.074C105.945 121.82 108.372 123.237 111 124.246",
                stroke: "#828282",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M148 126L154 132",
                stroke: "#828282",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153.029 131.031C151.136 132.924 151.136 135.992 153.029 137.885L164.114 148.97C166.007 150.863 169.076 150.863 170.968 148.97C172.861 147.078 172.861 144.009 170.968 142.116L159.883 131.031C157.99 129.138 154.922 129.138 153.029 131.031Z",
                fill: "#F2F2F2",
                stroke: "#828282",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M158 133L169 144",
                stroke: "white",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M114.001 88.0005C114.001 99.5985 123.403 109.001 135.001 109.001C137.279 109.001 139.472 108.638 141.527 107.967C138.174 116.288 130.023 122.161 120.501 122.161C107.985 122.161 97.8398 112.016 97.8398 99.5005C97.8398 88.1601 106.17 78.7653 117.046 77.1016C115.113 80.2798 114.001 84.0102 114.001 88.0005Z",
                fill: "#F2F2F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121 81C119.727 81 118.482 81.1253 117.279 81.3642M113.645 82.4761C106.804 85.3508 102 92.1144 102 100",
                stroke: "#E0E0E0",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M174.176 99.7773H166M180.5 92H163.324H180.5ZM187.5 92H185.279H187.5Z",
                stroke: "#E0E0E0",
                strokeWidth: "2.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.1743 121.777H75.9985M79.4985 113H62.3228H79.4985ZM56.4985 113H52.2773H56.4985Z",
                stroke: "#E0E0E0",
                strokeWidth: "2.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/SortAndFilteredItems/SortAndFilteredItems.styles.ts

function SortAndFilteredItems_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > section {\n    margin-top: 24px;\n    display: grid;\n    justify-self: center;\n    justify-items: center;\n    grid-auto-rows: auto;\n\n    @media screen and (min-width: ",
        "px) {\n      grid-template-columns: repeat(3, 1fr);\n      column-gap: 3rem;\n      row-gap: 2rem;\n      margin-left: ",
        ";\n      justify-self: baseline;\n      justify-items: baseline;\n    }\n    @media screen and (max-width: ",
        "px) {\n      grid-template-columns: repeat(2, 1fr);\n      margin-left: 0px;\n      column-gap: 20px;\n      row-gap: 15px;\n      justify-self: center;\n      justify-items: center;\n      ",
        ";\n    }\n  }\n"
    ]);
    SortAndFilteredItems_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SortAndFilteredItems_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    SortAndFilteredItems_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SortAndFilteredItems_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  postion: relative;\n  margin-top: 2rem;\n  @media screen and (min-width: ",
        "px) {\n    width: 60vw;\n  }\n"
    ]);
    SortAndFilteredItems_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var SortAndFilterItemsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortAndFilterItemsContainer",
    componentId: "sc-671aabb4-0"
})(SortAndFilteredItems_styles_templateObject(), constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "76px" : "0px";
}, constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "opacity : 0.2" : "opacity : 1";
});
var ItemsNotFoundSvgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemsNotFoundSvgContainer",
    componentId: "sc-671aabb4-1"
})(SortAndFilteredItems_styles_templateObject1());
var ItemsNotFoundContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemsNotFoundContainer",
    componentId: "sc-671aabb4-2"
})(SortAndFilteredItems_styles_templateObject2(), constants/* MAX_MOBILE_WIDTH */.Cf);

// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(780058);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(179220);
// EXTERNAL MODULE: ./src/containers/Collections/useGetTypeIdFromCanonicalDataStore.js
var useGetTypeIdFromCanonicalDataStore = __webpack_require__(130553);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/SortAndFilteredItems/SortAndFilteredItems.tsx










// import LoaderIcon from '@/components/Common/LoaderIcon';














var middleBodyScrollCorrectionOffset = 80;
var TYPE_TAG = 3;
function SortAndFilteredItems(props) {
    var checkIfShowPagination = function checkIfShowPagination() {
        var ref = gridAndPagination || {}, _pagination_style_desktop = ref.pagination_style_desktop, pagination_style_desktop = _pagination_style_desktop === void 0 ? "" : _pagination_style_desktop, _pagination_style_mobile = ref.pagination_style_mobile, pagination_style_mobile = _pagination_style_mobile === void 0 ? "" : _pagination_style_mobile;
        if (isMobile && pagination_style_mobile === PAGINATION) {
            return true;
        } else if (!isMobile && pagination_style_desktop === PAGINATION) {
            return true;
        }
        return false;
    };
    var getNoOfProductCount = function getNoOfProductCount() {
        var ref = gridAndPagination || {}, _num_products_desktop = ref.num_products_desktop, num_products_desktop = _num_products_desktop === void 0 ? "" : _num_products_desktop, _num_products_mobile = ref.num_products_mobile, num_products_mobile = _num_products_mobile === void 0 ? "" : _num_products_mobile, _pagination_style_desktop = ref.pagination_style_desktop, pagination_style_desktop = _pagination_style_desktop === void 0 ? "" : _pagination_style_desktop, _pagination_style_mobile = ref.pagination_style_mobile, pagination_style_mobile = _pagination_style_mobile === void 0 ? "" : _pagination_style_mobile;
        if (isMobile && num_products_mobile && pagination_style_mobile === PAGINATION) {
            return num_products_mobile;
        } else if (!isMobile && num_products_desktop && pagination_style_desktop === PAGINATION) {
            return num_products_desktop;
        }
        return 0;
    };
    var fetchDataOnCollectionCategoryChange = function fetchDataOnCollectionCategoryChange() {
        var ref = customRoute === null || customRoute === void 0 ? void 0 : customRoute.query, cid = ref.cid, collectionId = ref.collectionId;
        if (cid !== undefined || collectionId !== undefined) {
            dispatch((0,catalog/* setSortType */.Td)(constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES));
            dispatch((0,catalog/* resetFilterItems */.V$)());
            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                cid: cid,
                collectionId: collectionId,
                sortType: constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES,
                filterAppliedCounter: 0,
                isNextPage: true
            });
            plpInitFilterCall();
        }
    };
    var plpInitFilterCall = function plpInitFilterCall() {
        var ref, ref1;
        if (customRoute === null || customRoute === void 0 ? void 0 : (ref = customRoute.query) === null || ref === void 0 ? void 0 : ref.cid) {
            var selectedCategory = categories.find(function(categoryItem) {
                var ref;
                return (categoryItem === null || categoryItem === void 0 ? void 0 : categoryItem.id) == (customRoute === null || customRoute === void 0 ? void 0 : (ref = customRoute.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedCategory) {
                var ref2;
                var categoryFilterObject = {};
                var categorySubFilter = [];
                var subFilter = {};
                subFilter["id"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id;
                subFilter["name"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name;
                categorySubFilter.push(subFilter);
                categoryFilterObject["sub_filters"] = categorySubFilter;
                categoryFilterObject["name"] = "Categories";
                categoryFilterObject["type"] = 2;
                categoryFilterObject["is_selected"] = true;
                var filterArr = [
                    categoryFilterObject
                ];
                if (customRoute === null || customRoute === void 0 ? void 0 : (ref2 = customRoute.query) === null || ref2 === void 0 ? void 0 : ref2.collectionId) {
                    var collectionFilterObject = createCollectionFilterObject();
                    filterArr.push(collectionFilterObject);
                }
                dispatch((0,catalog/* saveFilteredOptions */.Pu)(filterArr));
                setInitialFilter(filterArr);
                plpFilterCall(filterArr, constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
            var selectedTag = productTags.find(function(tagItem) {
                var ref;
                return (tagItem === null || tagItem === void 0 ? void 0 : tagItem.id) == (customRoute === null || customRoute === void 0 ? void 0 : (ref = customRoute.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedTag) {
                var tagFilterObject = {};
                var tagSubFilter = [];
                var subFilter1 = {};
                subFilter1["id"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.id;
                subFilter1["name"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.name;
                tagSubFilter.push(subFilter1);
                tagFilterObject["sub_filters"] = tagSubFilter;
                tagFilterObject["name"] = "Tags";
                tagFilterObject["type"] = 3;
                tagFilterObject["is_selected"] = true;
                dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                    tagFilterObject
                ]));
                setInitialFilter([
                    tagFilterObject
                ]);
                plpFilterCall([
                    tagFilterObject
                ], constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
        } else if (customRoute === null || customRoute === void 0 ? void 0 : (ref1 = customRoute.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) {
            var collectionFilterObject1 = createCollectionFilterObject();
            dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                collectionFilterObject1
            ]));
            setInitialFilter([
                collectionFilterObject1
            ]);
            plpFilterCall([
                collectionFilterObject1
            ], constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
        }
    };
    var createCollectionFilterObject = function createCollectionFilterObject() {
        var collectionFilterObject = {};
        var collectionSubFilter = [];
        var subFilter = {};
        var selectedCollectionItem = collections.find(function(collectionItem) {
            var ref;
            return collectionItem.id == (customRoute === null || customRoute === void 0 ? void 0 : (ref = customRoute.query) === null || ref === void 0 ? void 0 : ref.collectionId);
        });
        subFilter["id"] = selectedCollectionItem === null || selectedCollectionItem === void 0 ? void 0 : selectedCollectionItem.id;
        subFilter["name"] = selectedCollectionItem === null || selectedCollectionItem === void 0 ? void 0 : selectedCollectionItem.name;
        collectionSubFilter.push(subFilter);
        collectionFilterObject["sub_filters"] = collectionSubFilter;
        collectionFilterObject["name"] = "Collections";
        collectionFilterObject["type"] = 1;
        collectionFilterObject["colour_code"] = "";
        collectionFilterObject["is_selected"] = true;
        return collectionFilterObject;
    };
    var changeinitialPlpCallToFalse = function changeinitialPlpCallToFalse(status, isNextPage, pageCount) {
        if (status) {
            initialPlpCall.current = false;
            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                isNextPage: isNextPage,
                pageNo: 1
            });
            setPageCount(pageCount);
        }
    };
    var plpFilterCall = function plpFilterCall(filterObject, sortType) {
        var payload = (0,_object_spread/* default */.Z)({
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: filterObject
        }, getNoOfProductCount() ? {
            items_per_page: getNoOfProductCount()
        } : {}, getNoOfProductCount() ? {
            storePrevitem: false
        } : {});
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload, changeinitialPlpCallToFalse));
    };
    var getSelectedFilters = /**
   * creates Payload of filters for sortAndFilterApi.
   * @returns {array} of selected filters.
   */ function getSelectedFilters() {
        var ref, ref1, ref2, ref3;
        /** add previous filteroption of collection and category and PLP page */ var tempFiltersArray = (customRoute === null || customRoute === void 0 ? void 0 : (ref = customRoute.query) === null || ref === void 0 ? void 0 : ref.cid) !== undefined || (customRoute === null || customRoute === void 0 ? void 0 : (ref1 = customRoute.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) !== undefined ? (0,_to_consumable_array/* default */.Z)(initialFilter) : [];
        if ((initialFilter === null || initialFilter === void 0 ? void 0 : (ref2 = initialFilter[0]) === null || ref2 === void 0 ? void 0 : ref2.type) === TYPE_TAG && (customRoute === null || customRoute === void 0 ? void 0 : (ref3 = customRoute.query) === null || ref3 === void 0 ? void 0 : ref3.cid)) {
            tempFiltersArray = [];
        }
        !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && filteredOptions.forEach(function(filterItem) {
            var ref;
            var tempFilterObject = {};
            var tempSubFilterArray = [];
            !!((ref = filterItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && filterItem.sub_filters.forEach(function(subFilterItem) {
                var tempSubFilters = {};
                if (subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.is_selected) {
                    tempSubFilters["id"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.id;
                    tempSubFilters["name"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.name;
                    tempSubFilters["colour_code"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.colour_code;
                    tempSubFilterArray.push(tempSubFilters);
                }
            });
            if (tempSubFilterArray === null || tempSubFilterArray === void 0 ? void 0 : tempSubFilterArray.length) {
                tempFilterObject["name"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.name;
                tempFilterObject["type"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.type;
                tempFilterObject["sub_filters"] = tempSubFilterArray;
                tempFiltersArray.push(tempFilterObject);
            }
        });
        return tempFiltersArray;
    };
    var removeDuplicateObjects = function removeDuplicateObjects(array) {
        array = Array.isArray(array) ? array : [];
        var uniqueObjects = [];
        var seenIds = new Set();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var obj = _step.value;
                var objectId = obj.id;
                if (!seenIds.has(objectId)) {
                    seenIds.add(objectId);
                    uniqueObjects.push(obj);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return uniqueObjects;
    };
    var returnFilterItemsData = function returnFilterItemsData() {
        var items = [];
        if (!mb7SortAndFilterConfig.allowReset) {
            items = mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredItems;
            dispatch((0,catalog/* saveFilteredItems */.tu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredItems) || []));
            dispatch((0,catalog/* saveFilteredOptions */.Pu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredOptions) || []));
        } else {
            items = filteredItems;
        }
        return removeDuplicateObjects(items);
    };
    var handleFilterCounterAndSortTypeChange = function handleFilterCounterAndSortTypeChange() {
        var ref, ref1;
        dispatch((0,catalog/* resetFilterItems */.V$)());
        loader.current = false;
        initialFilterSortTypeChangeCall.current = true;
        !isMobile && window.scrollTo({
            top: ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.middleBodyContainerRef) === null || ref === void 0 ? void 0 : ref.current.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.top) + window.scrollY - middleBodyScrollCorrectionOffset,
            left: 0,
            behavior: "instant"
        });
        var payload = (0,_object_spread/* default */.Z)({
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: getSelectedFilters()
        }, getNoOfProductCount() ? {
            items_per_page: getNoOfProductCount()
        } : {}, getNoOfProductCount() ? {
            storePrevitem: false
        } : {});
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload, function(status, isNextPage, pageCount) {
            if (status) {
                initialFilterSortTypeChangeCall.current = false;
                (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                    isNextPage: isNextPage,
                    pageNo: 1,
                    filterAppliedCounterChanged: false,
                    sortTypeChanged: false
                });
                setPageCount(pageCount);
            }
        }));
    };
    var loadPaginationItems = function loadPaginationItems(pageNo) {
        if (!isBuilder) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        var payload = (0,_object_spread/* default */.Z)({
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: pageNo,
            sorting_type: sortType,
            filters: getSelectedFilters()
        }, getNoOfProductCount() ? {
            items_per_page: getNoOfProductCount()
        } : {}, getNoOfProductCount() ? {
            storePrevitem: false
        } : {});
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload, function(status, isNextPage, pageCount) {
            if (status) {
                setPageCount(pageCount);
            }
        }));
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), pageStyle = ref4.widgetContextState.pageStyle;
    var ref5 = pageStyle || {}, _gridAndPagination = ref5.gridAndPagination, gridAndPagination = _gridAndPagination === void 0 ? {} : _gridAndPagination;
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref6.widgetContextState, globalStyle = _widgetContextState.globalStyle, isBuilder = _widgetContextState.isBuilder;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref7 = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)(), typeId = ref7.typeId, isTypeCollection = ref7.isTypeCollection;
    var customRoute = isBuilder ? {
        query: {
            cid: !(props === null || props === void 0 ? void 0 : props.isCollection) ? props.selectedId : undefined,
            collectionId: (props === null || props === void 0 ? void 0 : props.isCollection) ? props.selectedId : undefined
        }
    } : {
        query: isTypeCollection ? {
            collectionId: typeId
        } : {
            cid: typeId
        }
    };
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref8[0];
    var ref9 = (0,react.useState)([]), initialFilter = ref9[0], setInitialFilter = ref9[1];
    var ref10 = (0,react.useState)(0), pageCount = ref10[0], setPageCount = ref10[1];
    var ref11 = (0,es/* useSelector */.v9)(function(state) {
        return {
            filteredItems: state.catalogReducer.filteredItems,
            filteredOptions: state.catalogReducer.filteredOptions,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType,
            filterOptionLoader: state.commonReducer.filterOptionLoader
        };
    }), filteredItems = ref11.filteredItems, filteredOptions = ref11.filteredOptions, filterAppliedCounter = ref11.filterAppliedCounter, sortType = ref11.sortType, filterOptionLoader = ref11.filterOptionLoader;
    var ref12 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1, ref2;
        return {
            categories: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.categories,
            collections: (ref1 = state.catalogReducer) === null || ref1 === void 0 ? void 0 : ref1.collections,
            storeData: state.storeReducer.store,
            productTags: (ref2 = state.catalogReducer) === null || ref2 === void 0 ? void 0 : ref2.productTags
        };
    }), categories = ref12.categories, collections = ref12.collections, storeData = ref12.storeData, productTags = ref12.productTags;
    var loader = (0,react.useRef)(false);
    var initialPlpCall = (0,react.useRef)(true);
    var initialFilterSortTypeChangeCall = (0,react.useRef)(false);
    var mb7SortAndFilterConfig = (0,MiddleBody7_utils/* getStoredMB7SortAndFilterConfig */.Tr)();
    (0,react.useEffect)(function() {
        dispatch((0,common/* getHeroBannerHeightCalculation */.A4)());
    }, []);
    /**
   * If item is clicked and user navigates back to PLP, restore scroll to that particular item
   */ (0,react.useEffect)(function() {
        (0,MiddleBody7_utils/* scrollIfItemPreviouslyClicked */.Wu)();
    }, []);
    /**
   * If there is no change in filter from the one previously stored, then return. This prevents unnecessary API calls when component first mounts and each useeffect is called once.
   */ (0,react.useEffect)(function() {
        if ((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.allowReset) && (mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filterAppliedCounterChanged)) {
            handleFilterCounterAndSortTypeChange();
        }
    }, [
        filterAppliedCounter
    ]);
    (0,react.useEffect)(function() {
        if ((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.allowReset) && (mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.sortTypeChanged)) {
            handleFilterCounterAndSortTypeChange();
        }
    }, [
        sortType
    ]);
    (0,react.useEffect)(function() {
        if (mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.allowReset) {
            fetchDataOnCollectionCategoryChange();
        } else {
            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                allowReset: true
            });
            dispatch((0,catalog/* saveFilteredItems */.tu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredItems) || []));
            dispatch((0,catalog/* saveFilteredOptions */.Pu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredOptions) || []));
            dispatch((0,catalog/* setSortType */.Td)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.sortType) || constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES));
        }
    }, [
        customRoute === null || customRoute === void 0 ? void 0 : (ref = customRoute.query) === null || ref === void 0 ? void 0 : ref.cid,
        customRoute === null || customRoute === void 0 ? void 0 : (ref1 = customRoute.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId
    ]);
    function loadMoreItems() {
        return _loadMoreItems.apply(this, arguments);
    }
    function _loadMoreItems() {
        _loadMoreItems = (0,_async_to_generator/* default */.Z)(function() {
            var nextPageNumber, ref, status, is_next_page;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.isNextPage)) {
                            return [
                                2
                            ];
                        }
                        nextPageNumber = ((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.pageNo) || 0) + 1;
                        if (!(!loader.current && !initialPlpCall.current && !initialFilterSortTypeChangeCall.current)) return [
                            3,
                            2
                        ];
                        loader.current = true;
                        return [
                            4,
                            (0,getFilteredOptionProducts/* getFilteredOptionsProducts */.H)(getSelectedFilters(), nextPageNumber, {
                                isMiddleBody7: true
                            })
                        ];
                    case 1:
                        ref = _state.sent(), status = ref.status, is_next_page = ref.is_next_page;
                        if (status) {
                            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                                isNextPage: is_next_page,
                                pageNo: nextPageNumber
                            });
                        }
                        loader.current = false;
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _loadMoreItems.apply(this, arguments);
    }
    var handleCardClick = function(data) {
        (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
            filteredItems: filteredItems,
            filteredOptions: filteredOptions,
            filterAppliedCounter: filterAppliedCounter,
            allowReset: !(filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length),
            sortType: sortType
        }, true);
        onItemClick(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortAndFilterItemsContainer, {
            showFilterDrawer: props === null || props === void 0 ? void 0 : props.showFilterDrawer,
            showSortByDropDown: props === null || props === void 0 ? void 0 : props.showSortByDropDown,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                    isLoaderVisible: false,
                    isNext: true,
                    onScrollEnd: function() {
                        return !checkIfShowPagination() && loadMoreItems();
                    },
                    // add LoaderComponent for loading sections
                    renderInsideFragment: true,
                    renderList: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                            customClass: "tw-mt-[24px]",
                            productList: returnFilterItemsData(),
                            oldCardConfigs: {
                                showButton: true,
                                noTagsReadState: "fromLength",
                                onItemClick: handleCardClick
                            },
                            renderAdvancedCard: true,
                            calculateSelfDimensions: true
                        });
                    }
                }),
                loader.current && !!(mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.isNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center mt4 relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                        type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.loaderId) || "ellipsis",
                        color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref3 = globalStyle.appLoader) === null || ref3 === void 0 ? void 0 : ref3.color
                    })
                }),
                !(filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) && !!(mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.isNextPage) && !filterOptionLoader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemsNotFoundContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsNotFoundSvgContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsNotFound, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex w-100 justify-center",
                            children: "No Results Found"
                        })
                    ]
                }),
                checkIfShowPagination() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-my-[50px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                        totalPages: pageCount,
                        loadSelectedPageData: function(pageNo) {
                            return loadPaginationItems(pageNo);
                        }
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var SortAndFilteredItems_SortAndFilteredItems = (SortAndFilteredItems);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(414924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/utils.ts


var getFontWeightStyle = function(type) {
    switch(type){
        case "thin":
            return "300";
        case "regular":
            return "400";
        case "medium":
            return "500";
        case "semiBold":
            return "600";
        case "bold":
            return "700";
        default:
            return "400";
    }
};
var getFontSizeStyle = function(type) {
    var styles = {};
    switch(type){
        case "extraSmall":
            styles.fontSize = "12px";
            styles.lineHeight = "1";
            break;
        case "small":
            styles.fontSize = "13px";
            styles.lineHeight = "1";
            break;
        case "regular":
            styles.fontSize = "14px";
            styles.lineHeight = "1";
            break;
        case "medium":
            styles.fontSize = "16px";
            styles.lineHeight = "1.2";
            break;
        case "large":
            styles.fontSize = "18px";
            styles.lineHeight = "1.2";
            break;
        case "extraLarge":
            styles.fontSize = "20px";
            styles.lineHeight = "1.2";
            break;
        case "displayRegular":
            styles.fontSize = "28px";
            styles.lineHeight = "1.2";
            break;
        case "displayMedium":
            styles.fontSize = "36px";
            styles.lineHeight = "1.2";
            break;
        case "displayLarge":
            styles.fontSize = "48px";
            styles.lineHeight = "1.2";
            break;
        default:
            styles.fontSize = "16px";
            styles.lineHeight = "1.1";
            break;
    }
    return styles;
};
var getFilterTitleStyle = function(config, isMobile) {
    var ref = (config === null || config === void 0 ? void 0 : config.sortAndFilter) || {}, desktop_configs = ref.desktop_configs, mobile_configs = ref.mobile_configs, _title_color = ref.title_color, title_color = _title_color === void 0 ? "#000000" : _title_color, _title_thickness = ref.title_thickness, title_thickness = _title_thickness === void 0 ? "400" : _title_thickness, _title_case = ref.title_case, title_case = _title_case === void 0 ? "none" : _title_case;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getFontSizeStyle(isMobile ? (mobile_configs === null || mobile_configs === void 0 ? void 0 : mobile_configs.title_size) || "small" : (desktop_configs === null || desktop_configs === void 0 ? void 0 : desktop_configs.title_size) || "small")), {
        color: title_color,
        textTransform: title_case,
        fontWeight: getFontWeightStyle(title_thickness)
    });
};
var getFilterOptionStyle = function(config, isMobile) {
    var ref = (config === null || config === void 0 ? void 0 : config.sortAndFilter) || {}, desktop_configs = ref.desktop_configs, mobile_configs = ref.mobile_configs, _filter_options_color = ref.filter_options_color, filter_options_color = _filter_options_color === void 0 ? "#000000" : _filter_options_color, _filter_options_thickness = ref.filter_options_thickness, filter_options_thickness = _filter_options_thickness === void 0 ? "400" : _filter_options_thickness, _filter_options_case = ref.filter_options_case, filter_options_case = _filter_options_case === void 0 ? "none" : _filter_options_case;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getFontSizeStyle(isMobile ? (mobile_configs === null || mobile_configs === void 0 ? void 0 : mobile_configs.filter_options_size) || "small" : (desktop_configs === null || desktop_configs === void 0 ? void 0 : desktop_configs.filter_options_size) || "small")), {
        color: filter_options_color,
        textTransform: filter_options_case,
        fontWeight: getFontWeightStyle(filter_options_thickness)
    });
};
var getHeadingStyle = function(config, isMobile) {
    var ref = config || {}, text_size_desktop = ref.text_size_desktop, text_size_mobile = ref.text_size_mobile, _text_color = ref.text_color, text_color = _text_color === void 0 ? "#000000" : _text_color, _text_thickness = ref.text_thickness, text_thickness = _text_thickness === void 0 ? "400" : _text_thickness, _text_case = ref.text_case, text_case = _text_case === void 0 ? "none" : _text_case;
    return {
        fontSize: getFontSizeStyle(isMobile ? text_size_mobile || "regular" : text_size_desktop || "regular").fontSize,
        color: text_color,
        textTransform: text_case,
        fontWeight: getFontWeightStyle(text_thickness)
    };
};

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Constants/index.tsx
var Testimonials_Constants = __webpack_require__(16902);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(489429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/Accordian.tsx








function Accordian(props) {
    var handleAccordian = function handleAccordian() {
        setShowChild(!showChild);
        if (isLayout2) handleElementClick === null || handleElementClick === void 0 ? void 0 : handleElementClick(text);
    };
    var ref, ref1;
    var text = props.text, styleComp = props.styleComp, layoutType = props.layoutType, handleElementClick = props.handleElementClick, selectedElement = props.selectedElement, selectedFilterInfo = props.selectedFilterInfo;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var isLayout2 = layoutType === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO && !isMobile;
    var ref2 = (styleComp === null || styleComp === void 0 ? void 0 : styleComp.sortAndFilter) || {}, keep_filters_open = ref2.keep_filters_open, title_color = ref2.title_color;
    var ref3 = (0,react.useState)(isLayout2 ? false : keep_filters_open), showChild = ref3[0], setShowChild = ref3[1];
    var showChildElement = isLayout2 ? showChild && selectedElement === text : showChild;
    var dropdownRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!isLayout2) {
            setShowChild(keep_filters_open);
        }
    }, [
        keep_filters_open
    ]);
    (0,react.useEffect)(function() {
        if (isLayout2) {
            var handleClickOutside = function handleClickOutside(event) {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setShowChild(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: dropdownRef,
        className: "tw-flex tw-flex-col tw-gap-[16px] tw-relative ".concat(!isLayout2 ? "tw-w-[100%]" : "", " "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: (0,_object_spread/* default */.Z)({}, getFilterTitleStyle(styleComp, isMobile)),
                onClick: handleAccordian,
                className: "tw-flex tw-cursor-pointer tw-items-center ".concat(!isLayout2 ? "tw-justify-between" : "tw-gap-[4px] tw-p-[5px] hover:tw-bg-[#171C2A0D]", " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: text
                            }),
                            ((ref = selectedFilterInfo[text]) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "(".concat((ref1 = selectedFilterInfo[text]) === null || ref1 === void 0 ? void 0 : ref1.length, ")")
                            })
                        ]
                    }),
                    !isLayout2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            showChildElement && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: minusSvg(title_color)
                            }),
                            !showChildElement && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: plusSvg(title_color)
                            })
                        ]
                    }),
                    isLayout2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            !showChildElement && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "wb-sprite ic-arrow-down"
                            }),
                            showChildElement && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "wb-sprite ic-arrow-down inverted"
                            })
                        ]
                    })
                ]
            }),
            showChildElement && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        ".concat(isLayout2 ? " ".concat((ContentAnimationStyles_module_default()).widgetContentMoveDownWrapper, " tw-border tw-border-solid tw-border-[#111C3629] tw-bg-white\n           tw-absolute tw-bottom-0 tw-top-[30px] tw-p-[24px] !tw-z-[100] tw-h-max tw-max-h-[350px] tw-w-max tw-min-w-[150px] tw-max-w-[300px] tw-overflow-scroll") : ""),
                children: props.children
            }),
            !isLayout2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    borderBottom: "1px solid #111c3629"
                }
            })
        ]
    });
}
/* harmony default export */ var Component_Accordian = (Accordian);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/SortAndFilterContent.ts

var SortAndFilterContent = (0,react.createContext)({});

// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/FilterLayouts/ColorLayout2.tsx








function ColorLayout2(props) {
    var handleClick = function handleClick() {
        var eventData = {
            target: {
                checked: !(filterData === null || filterData === void 0 ? void 0 : filterData.is_selected)
            }
        };
        handleCheckboxClick === null || handleCheckboxClick === void 0 ? void 0 : handleCheckboxClick(eventData, filterName, filterData === null || filterData === void 0 ? void 0 : filterData.name);
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useContext)(SortAndFilterContent), handleCheckboxClick = ref3.handleCheckboxClick, pageStyle = ref3.pageStyle;
    var filterData = props.filterData, filterName = props.filterName, isType2 = props.isType2;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var storeInfo = (0,redux/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref4.widgetContextState, isBuilder = _widgetContextState.isBuilder, globalStyle = _widgetContextState.globalStyle;
    var themeColor = isBuilder ? globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.color) === null || ref === void 0 ? void 0 : ref.themeColor : storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: handleClick,
        className: "tw-flex tw-items-center ".concat(isType2 ? "tw-flex-col tw-gap-[8px] tw-w-[50px] " : "tw-gap-[10px] tw-w-[100px]", " tw-cursor-pointer"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    border: (filterData === null || filterData === void 0 ? void 0 : filterData.is_selected) ? "1px solid ".concat(themeColor) : ""
                },
                className: "tw-w-[22px] tw-h-[22px] tw-rounded-[50%] tw-flex tw-justify-center tw-items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        background: filterData === null || filterData === void 0 ? void 0 : filterData.colour_code
                    },
                    className: "tw-w-[16px] tw-h-[16px] tw-rounded-[50%]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,_object_spread/* default */.Z)({}, getFilterOptionStyle(pageStyle, isMobile)),
                className: "tw-text-[14px] tw-font-normal tw-text-[#111C36B2] ".concat((filterData === null || filterData === void 0 ? void 0 : filterData.is_selected) ? "tw-font-semibold tw-text-newBlack" : ""),
                children: filterData === null || filterData === void 0 ? void 0 : filterData.name
            })
        ]
    });
}
/* harmony default export */ var FilterLayouts_ColorLayout2 = (ColorLayout2);

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(759240);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/FilterLayouts/Layout1.tsx











function Layout1(props) {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useContext)(SortAndFilterContent), handleCheckboxClick = ref5.handleCheckboxClick, pageStyle = ref5.pageStyle;
    var filterData = props.filterData, type = props.type, filterName = props.filterName;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref6.widgetContextState, isBuilder = _widgetContextState.isBuilder, globalStyle = _widgetContextState.globalStyle;
    var storeInfo = (0,redux/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var themeColor = isBuilder ? (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.color) === null || ref === void 0 ? void 0 : ref.themeColor) || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) : storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color;
    var boxRadius = buttonStyle(globalStyle, 4, true);
    var borderRadiusVal = globalStyleValue(boxRadius === null || boxRadius === void 0 ? void 0 : boxRadius.borderRadius);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-[10px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                checked: filterData === null || filterData === void 0 ? void 0 : filterData.is_selected,
                handleChange: function(e) {
                    handleCheckboxClick === null || handleCheckboxClick === void 0 ? void 0 : handleCheckboxClick(e, filterName, filterData === null || filterData === void 0 ? void 0 : filterData.name);
                },
                borderRadius: Number(borderRadiusVal),
                selectedBackgroundColor: themeColor
            }),
            type === COLOUR && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    border: (filterData === null || filterData === void 0 ? void 0 : filterData.is_selected) ? "1px solid ".concat(themeColor) : ""
                },
                className: "tw-w-[22px] tw-h-[22px] tw-rounded-[50%] tw-flex tw-justify-center tw-items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        background: filterData === null || filterData === void 0 ? void 0 : filterData.colour_code
                    },
                    className: "tw-w-[16px] tw-h-[16px] tw-rounded-[50%]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,_object_spread/* default */.Z)({}, getFilterOptionStyle(pageStyle, isMobile)),
                className: "".concat((filterData === null || filterData === void 0 ? void 0 : filterData.is_selected) ? "tw-font-semibold tw-text-newBlack" : ""),
                children: filterData === null || filterData === void 0 ? void 0 : filterData.name
            })
        ]
    });
}
/* harmony default export */ var FilterLayouts_Layout1 = (Layout1);

// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/RenderViewMoreAndLess.tsx





var RenderViewMoreAndLess = function(props) {
    var ref, ref1, ref2, ref3;
    var ITEM_LIMIT = (props === null || props === void 0 ? void 0 : props.isLayout2) ? 10 : 5;
    var ref4 = (0,react.useState)(ITEM_LIMIT), numOfItemToShow = ref4[0], setNumOfItemToShow = ref4[1];
    var data = props.data, childComponent = props.childComponent, customClass = props.customClass;
    var storeInfo = (0,redux/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var ref5 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref5.widgetContextState, isBuilder = _widgetContextState.isBuilder, globalStyle = _widgetContextState.globalStyle;
    var themeColor = isBuilder ? globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.color) === null || ref === void 0 ? void 0 : ref.themeColor : storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,bundle_mjs/* twMerge */.m6)(customClass),
                children: (ref3 = data === null || data === void 0 ? void 0 : data.slice(0, numOfItemToShow)) === null || ref3 === void 0 ? void 0 : ref3.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: childComponent(item)
                    }, index);
                })
            }),
            numOfItemToShow < (data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    color: themeColor || "#000000"
                },
                className: "tw-text-[14px] tw-font-normal tw-cursor-pointer",
                onClick: function() {
                    return setNumOfItemToShow(data === null || data === void 0 ? void 0 : data.length);
                },
                children: [
                    "+ ".concat((data === null || data === void 0 ? void 0 : data.length) - ITEM_LIMIT),
                    " More"
                ]
            }),
            numOfItemToShow > ITEM_LIMIT && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: themeColor || "#000000"
                },
                className: "tw-text-[14px] tw-font-normal tw-cursor-pointer",
                onClick: function() {
                    return setNumOfItemToShow(ITEM_LIMIT);
                },
                children: "View Less"
            })
        ]
    });
};
/* harmony default export */ var Component_RenderViewMoreAndLess = (RenderViewMoreAndLess);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/RenderColourFilters.tsx






function RenderColourFilters(props) {
    var renderColourFilterAccToLayout = function renderColourFilterAccToLayout(item) {
        switch(color){
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayouts_Layout1, {
                    filterData: item,
                    type: COLOUR,
                    isSelect: false,
                    filterName: filterName
                });
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO:
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayouts_ColorLayout2, {
                    filterData: item,
                    type: COLOUR,
                    isSelect: false,
                    filterName: filterName,
                    isType2: color === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO
                });
        }
    };
    var ref;
    var data = props.data, config = props.config, filterName = props.filterName;
    var ref1 = config || {}, tmp = ref1.sortAndFilter, ref2 = tmp === void 0 ? {} : tmp, tmp1 = ref2.appearances, ref3 = tmp1 === void 0 ? {} : tmp1, _color = ref3.color, color = _color === void 0 ? "" : _color;
    var layout_desktop = config === null || config === void 0 ? void 0 : (ref = config.sortAndFilter) === null || ref === void 0 ? void 0 : ref.layout_desktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_RenderViewMoreAndLess, {
        isLayout2: layout_desktop === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO,
        data: data,
        childComponent: renderColourFilterAccToLayout,
        customClass: (COLOR_DIFF_LAYOUT === null || COLOR_DIFF_LAYOUT === void 0 ? void 0 : COLOR_DIFF_LAYOUT.includes(color)) ? FILTER_CUSTOM_CLASS_2 : FILTER_CUSTOM_CLASS
    });
}
/* harmony default export */ var Component_RenderColourFilters = (RenderColourFilters);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/FilterLayouts/Layout2.tsx









function Layout2(props) {
    var handleClick = function handleClick() {
        var eventData = {
            target: {
                checked: !(filterData === null || filterData === void 0 ? void 0 : filterData.is_selected)
            }
        };
        handleCheckboxClick === null || handleCheckboxClick === void 0 ? void 0 : handleCheckboxClick(eventData, filterName, filterData === null || filterData === void 0 ? void 0 : filterData.name);
    };
    var ref = (0,react.useContext)(SortAndFilterContent), handleCheckboxClick = ref.handleCheckboxClick, pageStyle = ref.pageStyle;
    var filterData = props.filterData, filterName = props.filterName, _isCustomType = props.isCustomType, isCustomType = _isCustomType === void 0 ? false : _isCustomType;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var ref1 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref1.widgetContextState.globalStyle;
    var globalRadius = buttonStyle(globalStyle, 6);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: (0,_object_spread/* default */.Z)({}, globalRadius),
        onClick: handleClick,
        className: "tw-border tw-cursor-pointer tw-border-solid ".concat(isCustomType ? "tw-flex tw-items-center tw-gap-[6px]" : "", " ").concat((filterData === null || filterData === void 0 ? void 0 : filterData.is_selected) ? "tw-border-[#2B74D8]" : "tw-border-[#111C3633]", " tw-p-[5px]"),
        children: [
            isCustomType && (filterData === null || filterData === void 0 ? void 0 : filterData.is_selected) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-pt-[2px]",
                children: selectedSvg()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,_object_spread/* default */.Z)({}, getFilterOptionStyle(pageStyle, isMobile)),
                className: "tw-text-[14px] tw-font-normal tw-text-[#111C36B2] ".concat((filterData === null || filterData === void 0 ? void 0 : filterData.is_selected) ? "tw-font-semibold tw-text-newBlack" : ""),
                children: filterData === null || filterData === void 0 ? void 0 : filterData.name
            })
        ]
    });
}
/* harmony default export */ var FilterLayouts_Layout2 = (Layout2);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/RenderSizeFilters.tsx






function RenderSizeFilters(props) {
    var renderSizeFilterAccToLayout = function renderSizeFilterAccToLayout(item) {
        switch(size){
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayouts_Layout1, {
                    filterData: item,
                    type: SIZE,
                    isSelect: false,
                    filterName: filterName
                });
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayouts_Layout2, {
                    filterData: item,
                    type: SIZE,
                    isSelect: false,
                    filterName: filterName
                });
        }
    };
    var ref;
    var data = props.data, config = props.config, filterName = props.filterName;
    var tmp = config.sortAndFilter, ref1 = tmp === void 0 ? {} : tmp, tmp1 = ref1.appearances, ref2 = tmp1 === void 0 ? {} : tmp1, _size = ref2.size, size = _size === void 0 ? "" : _size;
    var layout_desktop = config === null || config === void 0 ? void 0 : (ref = config.sortAndFilter) === null || ref === void 0 ? void 0 : ref.layout_desktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_RenderViewMoreAndLess, {
        isLayout2: layout_desktop === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO,
        data: data,
        childComponent: renderSizeFilterAccToLayout,
        customClass: (COLOR_DIFF_LAYOUT === null || COLOR_DIFF_LAYOUT === void 0 ? void 0 : COLOR_DIFF_LAYOUT.includes(size)) ? FILTER_CUSTOM_CLASS_2 : FILTER_CUSTOM_CLASS
    });
}
/* harmony default export */ var Component_RenderSizeFilters = (RenderSizeFilters);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/CustomFilter.tsx






function CustomFilter(props) {
    var renderCustomFilterAccToLayout = function renderCustomFilterAccToLayout(item) {
        switch(currentLayout){
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayouts_Layout1, {
                    filterData: item,
                    type: CUSTOM,
                    isSelect: false,
                    filterName: filterName
                });
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLayouts_Layout2, {
                    filterData: item,
                    isSelect: false,
                    filterName: filterName,
                    isCustomType: true
                });
        }
    };
    var ref;
    var data = props.data, config = props.config, filterName = props.filterName, filterId = props.filterId;
    var tmp = config.sortAndFilter, ref1 = tmp === void 0 ? {} : tmp, _appearances = ref1.appearances, appearances = _appearances === void 0 ? {} : _appearances;
    var layout_desktop = config === null || config === void 0 ? void 0 : (ref = config.sortAndFilter) === null || ref === void 0 ? void 0 : ref.layout_desktop;
    var currentLayout = (appearances === null || appearances === void 0 ? void 0 : appearances[filterId]) || Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_RenderViewMoreAndLess, {
        isLayout2: layout_desktop === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO,
        data: data,
        childComponent: renderCustomFilterAccToLayout,
        customClass: (COLOR_DIFF_LAYOUT === null || COLOR_DIFF_LAYOUT === void 0 ? void 0 : COLOR_DIFF_LAYOUT.includes(currentLayout)) ? FILTER_CUSTOM_CLASS_2 : FILTER_CUSTOM_CLASS
    });
}
/* harmony default export */ var Component_CustomFilter = (CustomFilter);

// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(758826);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(496486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/SortAndFilter.tsx
























var SortAndFilter = function(props) {
    var handleElementClick = function handleElementClick(id) {
        setSelectedElement(id);
    };
    var showClearAll = function showClearAll() {
        var ref;
        var updateSelectedFilter = (0,_object_spread/* default */.Z)({}, selectedFilterInfo);
        var showClearAllOption = false;
        (ref = Object.keys(updateSelectedFilter)) === null || ref === void 0 ? void 0 : ref.map(function(headingKey) {
            var ref;
            if ((ref = updateSelectedFilter[headingKey]) === null || ref === void 0 ? void 0 : ref.length) {
                showClearAllOption = true;
            }
        });
        return showClearAllOption;
    };
    var getFilterStyle = function getFilterStyle() {
        var ref = (pageStyle === null || pageStyle === void 0 ? void 0 : pageStyle.sortAndFilter) || {}, _title_color = ref.title_color, title_color = _title_color === void 0 ? "" : _title_color, _title_thickness = ref.title_thickness, title_thickness = _title_thickness === void 0 ? "" : _title_thickness;
        return {
            color: title_color,
            fontWeight: getFontWeightStyle(title_thickness)
        };
    };
    var handleViewMoreClick = function handleViewMoreClick() {
        setIsViewMore(function(prev) {
            return !prev;
        });
    };
    var removeSelectedFilter = function removeSelectedFilter(filterName, value) {
        var updatedFilter = (0,lodash.cloneDeep)(selectedFilterInfo);
        var selectedFilterHeading = Object.keys(updatedFilter || {});
        var filteredData = selectedFilterHeading === null || selectedFilterHeading === void 0 ? void 0 : selectedFilterHeading.reduce(function(acc, curr) {
            if (filterName === curr) {
                var ref;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, curr, (ref = updatedFilter[curr]) === null || ref === void 0 ? void 0 : ref.filter(function(val) {
                    return val !== value;
                })));
            } else {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, curr, updatedFilter[curr]));
            }
        }, {});
        setSelectedFilterInfo(filteredData);
    };
    var handleClearAllFilter = function handleClearAllFilter() {
        var tempFilterOptions = filterOption === null || filterOption === void 0 ? void 0 : filterOption.slice(filterOption, filterOption === null || filterOption === void 0 ? void 0 : filterOption.length);
        for(var i = 0; i < (tempFilterOptions === null || tempFilterOptions === void 0 ? void 0 : tempFilterOptions.length); i++){
            var ref, ref1;
            for(var j = 0; j < ((ref = tempFilterOptions[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.sub_filters) === null || ref1 === void 0 ? void 0 : ref1.length); j++){
                if (tempFilterOptions[i].sub_filters[j]["is_selected"]) {
                    tempFilterOptions[i].sub_filters[j]["is_selected"] = false;
                }
            }
        }
        var filterCounter = constants/* FILTER_COUNTER_OPTIONS.DEC */.zO.DEC;
        dispatch((0,catalog/* filtersCounter */.Ds)(filterCounter));
        dispatch((0,catalog/* saveFilteredOptions */.Pu)(tempFilterOptions));
        setSelectedFilterInfo({});
        (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
            filterAppliedCounterChanged: true
        });
    };
    var handleCheckboxClick = function handleCheckboxClick(e, filterOptionName, subFilterName) {
        var _loop = function(i) {
            var ref;
            if (filterOptionName === ((ref = tempFilterOptions[i]) === null || ref === void 0 ? void 0 : ref.name)) {
                var _loop = function(j) {
                    var ref;
                    if (subFilterName === ((ref = tempFilterOptions[i].sub_filters[j]) === null || ref === void 0 ? void 0 : ref.name)) {
                        if (e.target.checked) {
                            setSelectedFilterInfo(function(prev) {
                                var ref, ref1, ref2;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, (ref = tempFilterOptions[i]) === null || ref === void 0 ? void 0 : ref.name, (0,_to_consumable_array/* default */.Z)(prev[(ref1 = tempFilterOptions[i]) === null || ref1 === void 0 ? void 0 : ref1.name] || []).concat([
                                    (ref2 = tempFilterOptions[i].sub_filters[j]) === null || ref2 === void 0 ? void 0 : ref2.name
                                ])));
                            });
                        } else {
                            var ref1, ref2;
                            removeSelectedFilter((ref1 = tempFilterOptions[i]) === null || ref1 === void 0 ? void 0 : ref1.name, (ref2 = tempFilterOptions[i].sub_filters[j]) === null || ref2 === void 0 ? void 0 : ref2.name);
                        }
                        e.target.checked ? tempFilterOptions[i].sub_filters[j]["is_selected"] = true : tempFilterOptions[i].sub_filters[j]["is_selected"] = false;
                        return "break";
                    }
                };
                var ref1, ref2;
                for(var j = 0; j < ((ref1 = tempFilterOptions[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sub_filters) === null || ref2 === void 0 ? void 0 : ref2.length); j++){
                    var _ret = _loop(j);
                    if (_ret === "break") break;
                }
            }
        };
        var ref;
        e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
        var tempFilterOptions = filterOption === null || filterOption === void 0 ? void 0 : filterOption.slice(filterOption, filterOption === null || filterOption === void 0 ? void 0 : filterOption.length);
        for(var i = 0; i < (tempFilterOptions === null || tempFilterOptions === void 0 ? void 0 : tempFilterOptions.length); i++)_loop(i);
        var filterCounter = e.target.checked ? constants/* FILTER_COUNTER_OPTIONS.INC */.zO.INC : constants/* FILTER_COUNTER_OPTIONS.DEC */.zO.DEC;
        dispatch((0,catalog/* filtersCounter */.Ds)(filterCounter));
        dispatch((0,catalog/* saveFilteredOptions */.Pu)(tempFilterOptions));
        (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
            filterAppliedCounterChanged: true
        });
    };
    var checkViewMoreOption = function checkViewMoreOption(filterData) {
        var filterLength = filterData === null || filterData === void 0 ? void 0 : filterData.reduce(function(acc, curr) {
            var ref;
            if ((curr === null || curr === void 0 ? void 0 : (ref = curr.sub_filters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                acc += 1;
            }
            return acc;
        }, 0);
        return filterLength > 5;
    };
    var renderSubFilters = function renderSubFilters(data) {
        var subFilterData = data === null || data === void 0 ? void 0 : data.sub_filters;
        var filterName = data === null || data === void 0 ? void 0 : data.name;
        var filterId = data === null || data === void 0 ? void 0 : data.id;
        switch(filterName){
            case COLOUR:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_RenderColourFilters, {
                    data: subFilterData,
                    config: pageStyle,
                    filterName: filterName
                });
            case SIZE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_RenderSizeFilters, {
                    data: subFilterData,
                    config: pageStyle,
                    filterName: filterName
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_CustomFilter, {
                    data: subFilterData,
                    config: pageStyle,
                    filterName: filterName,
                    filterId: filterId
                });
        }
    };
    var renderSelectedFilter = function renderSelectedFilter() {
        var selectedFilterHeading = Object.keys(selectedFilterInfo || {});
        var eventDetails = {
            target: {
                checked: false
            }
        };
        return (selectedFilterHeading === null || selectedFilterHeading === void 0 ? void 0 : selectedFilterHeading.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-items-center ".concat(desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO ? "tw-gap-[12px]" : "tw-gap-[8px]", " tw-flex-wrap"),
            children: selectedFilterHeading === null || selectedFilterHeading === void 0 ? void 0 : selectedFilterHeading.map(function(heading) {
                var filterOption = (selectedFilterInfo === null || selectedFilterInfo === void 0 ? void 0 : selectedFilterInfo[heading]) || [];
                return filterOption === null || filterOption === void 0 ? void 0 : filterOption.map(function(subFilterHeading, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: (0,_object_spread/* default */.Z)({}, globalRadius),
                        className: "tw-flex tw-items-center tw-gap-[8px] tw-px-[12px] tw-py-[8px] tw-border tw-border-solid tw-border-[#111C361F]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " tw-text-[13px] tw-font-normal tw-opacity-70 tw-text-newBlack ",
                                children: "".concat(heading, ": ").concat(subFilterHeading)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-cursor-pointer tw-h-[16px]",
                                onClick: function() {
                                    return handleCheckboxClick(eventDetails, heading, subFilterHeading);
                                },
                                children: crossSvg()
                            })
                        ]
                    }, subFilterHeading + index);
                });
            })
        });
    };
    var sortAndFilterContent = function sortAndFilterContent(layoutType) {
        var filterDataAccToLayout = isLayout2 && isViewMore ? updatedFilterOption === null || updatedFilterOption === void 0 ? void 0 : updatedFilterOption.slice(0, 5) : updatedFilterOption;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(!isLayout1 ? "tw-sticky tw-top-[75px]" : "", " ").concat(isLayout3 || isLayout2 ? "tw-w-[100%]" : !isMobile ? "tw-w-[25%]" : "", " ").concat(isMobile ? "tw-w-[100%]" : "tw-min-w-[300px]", "\n      tw-flex tw-flex-col tw-gap-[24px] ").concat(!isLayout2 ? "tw-px-[40px]" : !isScrollView ? "tw-mb-[16px]" : "", " ").concat(isMobile ? "!tw-px-[16px]" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(isLayout2 ? "tw-flex tw-items-start tw-gap-[12px]" : ""),
                    children: [
                        isLayout2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-pt-[7.5px]",
                            style: (0,_object_spread/* default */.Z)({}, getFilterTitleStyle(pageStyle, isMobile)),
                            children: "Filter by:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                !isLayout2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-justify-between ".concat(isLayout3 || isMobile ? "tw-mt-[20px]" : "", " "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: (0,_object_spread/* default */.Z)({}, getFilterStyle()),
                                            className: "tw-text-[20px] tw-leading-[36px] ",
                                            children: "Filters"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-items-center tw-gap-[8px]",
                                            children: desktopLayout !== Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return hideFilter(false);
                                                },
                                                className: "wb-sprite ic-cross-black"
                                            })
                                        })
                                    ]
                                }),
                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        margin: "20px -40px 0px -40px"
                                    },
                                    className: "tw-border tw-border-solid tw-border-[#111C3629] tw-mt-[20px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        height: isLayout3 ? "90vh" : ""
                                    },
                                    className: "no-scrollbar tw-flex tw-items-center ".concat(isMobile ? " !tw-h-[85.5vh]" : "", " ").concat(!isLayout2 ? "tw-flex-col tw-pt-[24px] tw-gap-[24px] tw-pb-[20px] ".concat(isLayout3 || isMobile ? "tw-overflow-auto" : "") : "tw-flex-wrap tw-gap-[11px]"),
                                    children: [
                                        !isLayout2 && showClearAll() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-mt-[8px] tw-w-[100%] tw-pb-[24px] tw-border-b tw-border-solid tw-border-[#111C3629] tw-flex tw-flex-col tw-gap-[16px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: renderSelectedFilter()
                                                }),
                                                showClearAll() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    onClick: function() {
                                                        return handleClearAllFilter();
                                                    },
                                                    className: "tw-flex tw-items-center tw-opacity-70 tw-gap-[4px] tw-cursor-pointer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: crossSvg()
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "tw-text-[13px] tw-font-normal tw-text-newBlack tw-underline",
                                                            children: "Clear all filters"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        (filterDataAccToLayout === null || filterDataAccToLayout === void 0 ? void 0 : filterDataAccToLayout.length) && (filterDataAccToLayout === null || filterDataAccToLayout === void 0 ? void 0 : filterDataAccToLayout.map(function(data) {
                                            var ref;
                                            return (data === null || data === void 0 ? void 0 : (ref = data.sub_filters) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_Accordian, {
                                                styleComp: pageStyle,
                                                selectedFilterInfo: selectedFilterInfo,
                                                text: data === null || data === void 0 ? void 0 : data.name,
                                                layoutType: layoutType,
                                                selectedElement: selectedElement,
                                                handleElementClick: function(id) {
                                                    return handleElementClick(id);
                                                },
                                                children: renderSubFilters(data)
                                            }, data === null || data === void 0 ? void 0 : data.name);
                                        })),
                                        isLayout2 && checkViewMoreOption(filterDataAccToLayout) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: (0,_object_spread/* default */.Z)({}, getFilterTitleStyle(pageStyle, isMobile)),
                                            onClick: handleViewMoreClick,
                                            className: " !tw-font-bold tw-cursor-pointer",
                                            children: isViewMore ? "+ View more" : "- View less"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !isScrollView && isLayout2 && showClearAll() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[12px]",
                    children: [
                        renderSelectedFilter(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: function() {
                                return handleClearAllFilter();
                            },
                            className: "tw-flex tw-items-center tw-gap-[4px] tw-opacity-70 tw-cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: crossSvg()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-[13px] tw-font-normal tw-text-newBlack tw-underline",
                                    children: "Clear all filters"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderAccordingToLayout = function renderAccordingToLayout() {
        if (!isMobile) {
            switch(desktopLayout){
                case Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[24px] tw-max-w-[300px]",
                        children: sortAndFilterContent(desktopLayout)
                    });
                case Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO:
                    return sortAndFilterContent(desktopLayout);
                case Testimonials_Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                        className: "tw-z-[600] tw-select-none",
                        open: showFilters,
                        onClose: function() {
                            return hideFilter(false);
                        },
                        sx: {
                            "& .MuiDrawer-paper": {
                                width: "35%"
                            }
                        },
                        children: sortAndFilterContent(desktopLayout)
                    });
            }
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-flex-col tw-gap-[24px] tw-w-[100%]",
                children: sortAndFilterContent(desktopLayout)
            });
        }
    };
    var ref;
    var filterOption = props.filterOption, showFilters = props.showFilters, hideFilter = props.hideFilter, isViewMore = props.isViewMore, setIsViewMore = props.setIsViewMore, selectedFilterInfo = props.selectedFilterInfo, setSelectedFilterInfo = props.setSelectedFilterInfo, _isScrollView = props.isScrollView, isScrollView = _isScrollView === void 0 ? false : _isScrollView;
    var ref1 = (0,react.useState)(""), selectedElement = ref1[0], setSelectedElement = ref1[1];
    var ref2 = (0,react.useState)(filterOption), updatedFilterOption = ref2[0], setUpdatedFilterOption = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref3.widgetContextState, pageStyle = _widgetContextState.pageStyle, globalStyle = _widgetContextState.globalStyle;
    var desktopLayout = pageStyle === null || pageStyle === void 0 ? void 0 : (ref = pageStyle.sortAndFilter) === null || ref === void 0 ? void 0 : ref.layout_desktop;
    var isLayout3 = isMobile ? false : desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE;
    var isLayout2 = isMobile ? false : desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO;
    var isLayout1 = desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE;
    var globalRadius = buttonStyle(globalStyle, 6);
    (0,react.useEffect)(function() {
        setUpdatedFilterOption(filterOption);
    }, [
        filterOption
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (filterOption === null || filterOption === void 0 ? void 0 : filterOption.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilterContent.Provider, {
            value: {
                handleCheckboxClick: handleCheckboxClick,
                pageStyle: pageStyle
            },
            children: renderAccordingToLayout()
        }) : null
    });
};
/* harmony default export */ var SortAndFilter_SortAndFilter = (SortAndFilter);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/index.tsx


// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(496664);
// EXTERNAL MODULE: ./src/constants/builderConstants.ts
var builderConstants = __webpack_require__(779834);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/Component/FilterHeading.tsx











function FilterHeading(props) {
    var renderImageHeading = function renderImageHeading() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    margin: isBannerFullWidth ? isMobile ? "0 -1rem" : "0" : isMobile ? "0" : "0 1rem",
                    height: bannerImageHeight
                },
                className: "tw-relative ".concat(!isMobile ? "tw-pb-[20px]" : "", " ").concat(!isBannerFullWidth && isMobile ? "!tw-mt-[16px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (selectedCatCol === null || selectedCatCol === void 0 ? void 0 : (ref = selectedCatCol.data) === null || ref === void 0 ? void 0 : ref.image_url) || builderConstants/* RICH_TEXT_IMAGE */.O8,
                        height: bannerImageHeight,
                        className: "tw-object-cover",
                        width: "100%"
                    }),
                    textPostion && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: renderTextHeading(true)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[1] tw-bg-black tw-pb-[20px]",
                        style: {
                            background: "rgba(0,0,0, ".concat((imageOverlay || 1) / 100 || 0.2, ")"),
                            height: bannerImageHeight
                        }
                    })
                ]
            })
        });
    };
    var renderTextHeading = function renderTextHeading() {
        var isTextOnImage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref, ref1, ref2;
        var selectedIdProductCount = (catalog_items === null || catalog_items === void 0 ? void 0 : (ref1 = catalog_items[selectedCatCol === null || selectedCatCol === void 0 ? void 0 : (ref = selectedCatCol.data) === null || ref === void 0 ? void 0 : ref.id]) === null || ref1 === void 0 ? void 0 : ref1.length) || 0;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getHeadingStyle(currentWidgetType, isMobile)), {
                margin: !isTextOnImage && isMobile ? "0 -1rem" : ""
            }),
            className: "".concat(isFullWidthHeading && !isTextOnImage ? "tw-flex tw-flex-col tw-justify-center tw-border-b tw-border-solid tw-border-[#111c3629] ".concat(!isMobile ? "tw-min-h-[108px]" : "", " ").concat(textAlignment === "left" ? "tw-items-start tw-pl-[56px]}" : "tw-text-center") : "", "\n         ").concat(isTextOnImage ? "tw-absolute tw-top-[0px] !tw-z-20  tw-flex tw-h-[100%]  tw-w-[100%] tw-flex-col tw-justify-center ".concat(textAlignment === "left" ? "tw-items-start ".concat(isMobile ? "tw-pl-[24px]" : "tw-pl-[56px]") : "tw-text-center") : "", "\n        "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,bundle_mjs/* twMerge */.m6)("".concat(!isFullWidthHeading && isMobile ? "tw-border-b tw-border-solid tw-border-[#111c3629] tw-py-[24px]" : ""), "".concat(!isTextOnImage && isMobile ? "tw-px-[16px]" : "")),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: getHeadingStyle(currentWidgetType, isMobile),
                        children: (selectedCatCol === null || selectedCatCol === void 0 ? void 0 : (ref2 = selectedCatCol.data) === null || ref2 === void 0 ? void 0 : ref2.name) || "COLLECTION"
                    }),
                    !isTextOnImage && !isMobile && !!selectedIdProductCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-ml-8 tw-text-[13px] tw-font-normal tw-text-newBlack tw-opacity-70",
                        children: [
                            "(",
                            "".concat(selectedIdProductCount, " ").concat(selectedIdProductCount > 1 ? "products" : "product"),
                            ")"
                        ]
                    })
                ]
            })
        });
    };
    var ref;
    var isCollection = props.isCollection, selectedCatCol = props.selectedCatCol;
    var ref1 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), pageStyle = ref1.widgetContextState.pageStyle;
    var catalog_items = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalog_items: state.catalogReducer.catalog_items
        };
    }).catalog_items;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var currentWidgetType = isCollection ? pageStyle === null || pageStyle === void 0 ? void 0 : pageStyle.caligraphyCollection : pageStyle === null || pageStyle === void 0 ? void 0 : pageStyle.caligraphyCategory;
    var currentHeadingType = currentWidgetType === null || currentWidgetType === void 0 ? void 0 : currentWidgetType.heading_type;
    var isBannerFullWidth = currentWidgetType === null || currentWidgetType === void 0 ? void 0 : currentWidgetType.isBannerFullWidth;
    var imageOverlay = currentWidgetType === null || currentWidgetType === void 0 ? void 0 : currentWidgetType.overlay;
    var textPostion = (currentWidgetType === null || currentWidgetType === void 0 ? void 0 : currentWidgetType.text_placement) === IS_TEXT_ON_IMAGE;
    var isFullWidthHeading = (pageStyle === null || pageStyle === void 0 ? void 0 : (ref = pageStyle.sortAndFilter) === null || ref === void 0 ? void 0 : ref.layout_desktop) !== Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE;
    var textAlignment = currentWidgetType === null || currentWidgetType === void 0 ? void 0 : currentWidgetType.text_alignment;
    var bannerImageHeight = isMobile ? 240 : currentWidgetType.height;
    return currentHeadingType === HEADING_TYPE_IMAGE ? renderImageHeading() : renderTextHeading();
}
/* harmony default export */ var Component_FilterHeading = (FilterHeading);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/SortAndFilter/SortAndFilterMobile.tsx













var SortAndFilterMobile = function(props) {
    var handleClick = function handleClick(name) {
        if (name === "Sort" || showSortInMobile) {
            setShowSortInMobile(!showSortInMobile);
        }
        setIsFilterActive(!isFilterActive);
    };
    var getStyleByLayout = function getStyleByLayout() {
        var style = {
            margin: "0 -16px"
        };
        if (isBuilder) {
            style = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                width: "360px"
            });
        }
        switch(mobileLayout){
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                    top: -20,
                    borderRadius: "0px",
                    borderBottom: "1px solid #111C361F"
                });
            case Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO:
                if (isBuilder) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                        bottom: 32,
                        borderRadius: "0 0 8px 8px",
                        borderTop: "1px solid #111C361F"
                    });
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                        bottom: 0,
                        borderTop: "1px solid #111C361F"
                    });
                }
            default:
                return {};
        }
    };
    var renderSortOption = function renderSortOption() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-h-max tw-w-[100%]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-w-[100%] tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-[#111C361F] tw-p-[16px] ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                color: pageStyle === null || pageStyle === void 0 ? void 0 : (ref = pageStyle.sortAndFilter) === null || ref === void 0 ? void 0 : ref.title_color
                            },
                            className: "tw-text-[16px] tw-font-normal",
                            children: "Sort by"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return handleClick("Sort");
                            },
                            className: "wb-sprite ic-cross-black"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-gap-[20px] tw-px-[16px] tw-py-[22px]",
                    children: updatedSortList === null || updatedSortList === void 0 ? void 0 : updatedSortList.map(function(item, index) {
                        var isSelected = sortType === item.type;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-gap-[10px]",
                            onClick: function(e) {
                                props === null || props === void 0 ? void 0 : props.handleSortItemClick(e, item);
                                handleClick("Sort");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        border: "1px solid ".concat(isSelected ? themeColor : "#000000")
                                    },
                                    className: "tw-relative tw-flex tw-h-[18px] tw-w-[18px] tw-items-center tw-justify-center tw-rounded-[50%]",
                                    children: isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            background: themeColor
                                        },
                                        className: "tw-absolute tw-h-[12px] tw-w-[12px] tw-rounded-[50%] "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: (0,_object_spread/* default */.Z)({}, getFilterOptionStyle(pageStyle, true)),
                                    className: isSelected ? "!tw-font-semibold" : "!tw-font-normal",
                                    children: item === null || item === void 0 ? void 0 : item.name
                                })
                            ]
                        }, index);
                    })
                })
            ]
        });
    };
    var renderFilterForMobile = function renderFilterForMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-relative tw-h-[100%] tw-w-[100%] tw-bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilter_SortAndFilter, (0,_object_spread/* default */.Z)({}, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-absolute tw-bottom-0 tw-flex tw-w-[100%] tw-items-center tw-justify-between tw-gap-[8px] tw-border-t tw-border-solid tw-border-[#111C361F] tw-bg-white tw-px-[16px] tw-py-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return handleClick("Cancel");
                            },
                            className: "tw-flex tw-w-[50%] tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[8px] tw-border tw-border-solid tw-border-[#111C361F] tw-px-[16px] tw-py-[12px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-text-[14px] tw-font-normal tw-text-newBlack",
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                background: themeColor
                            },
                            onClick: function() {
                                return handleClick("Apply");
                            },
                            className: "tw-flex tw-w-[50%] tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[8px] tw-px-[16px] tw-py-[12px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-text-[14px] tw-font-normal tw-text-white",
                                children: "Apply filters"
                            })
                        })
                    ]
                })
            ]
        });
    };
    var renderSortForMobile = function renderSortForMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-relative tw-h-[100%] tw-w-[100%]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-bottom-0 tw-flex tw-w-[100%] tw-flex-col tw-bg-white",
                children: renderSortOption()
            })
        });
    };
    var renderFilters = function renderFilters() {
        var ref, ref1;
        var selectedIdProductCount = (catalog_items === null || catalog_items === void 0 ? void 0 : (ref1 = catalog_items[selectedCatCol === null || selectedCatCol === void 0 ? void 0 : (ref = selectedCatCol.data) === null || ref === void 0 ? void 0 : ref.id]) === null || ref1 === void 0 ? void 0 : ref1.length) || 0;
        return !isFilterActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: mobileRef,
            style: (0,_object_spread/* default */.Z)({}, getStyleByLayout()),
            className: "".concat(isLayout1 ? "" : "tw-fixed", " !tw-z-[100] tw-flex tw-items-center tw-justify-between\n     tw-gap-[20px] tw-bg-white tw-px-[16px] tw-pt-[16px] tw-pb-8\n     "),
            children: [
                !isEssentialType && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return handleClick("Filter");
                    },
                    className: "tw-flex tw-w-[132px] tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[8px] tw-px-[16px] tw-py-[12px]",
                    children: [
                        filterIcon(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-[14px] tw-font-normal tw-text-newBlack",
                            children: "Filters ".concat(selectedFilterCount > 0 ? "(".concat(selectedFilterCount, ")") : "")
                        })
                    ]
                }),
                isEssentialType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-text-[12px] tw-font-normal tw-text-newBlack tw-opacity-70",
                    children: "".concat(selectedIdProductCount, " ").concat(selectedIdProductCount > 1 ? "products" : "product")
                }),
                !isEssentialType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-h-[28px] tw-w-[1px] tw-bg-[#111C361F]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return handleClick("Sort");
                    },
                    className: " ".concat(!isEssentialType ? "tw-w-[132px] tw-items-center tw-justify-center tw-px-[16px]" : "tw-pl-[16px] ", " tw-flex tw-cursor-pointer tw-gap-[8px]  tw-py-[12px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "wb-sprite sort-filter"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-[15px] tw-font-normal tw-text-newBlack",
                            children: "Sort by"
                        })
                    ]
                })
            ]
        });
    };
    var scrollStateFilter = function scrollStateFilter() {
        var ref, ref1, ref2;
        return !isFilterActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getStyleByLayout()), {
                top: isBuilder ? (headerRef === null || headerRef === void 0 ? void 0 : (ref = headerRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) + 66 : 0,
                width: isBuilder ? mobileRef === null || mobileRef === void 0 ? void 0 : (ref1 = mobileRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth : "100%"
            }),
            className: "".concat(isLayout1 ? "" : "tw-fixed", " !tw-z-[100] tw-flex tw-items-center tw-justify-between\n     tw-gap-[20px] tw-border-t tw-border-solid tw-border-[#111C361F] tw-bg-white tw-px-[16px] tw-py-[8px] ").concat(isSticky ? "tw-fixed " : "", "\n     "),
            children: [
                !isEssentialType && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return handleClick("Filter");
                    },
                    className: "tw-flex tw-w-[132px] tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[8px] tw-px-[16px] tw-py-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "",
                            children: filterIcon()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-[14px] tw-font-normal tw-text-newBlack",
                            children: "Filters ".concat(selectedFilterCount > 0 ? "(".concat(selectedFilterCount, ")") : "")
                        })
                    ]
                }),
                isEssentialType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-text-[15px] tw-font-normal tw-text-newBlack tw-opacity-70",
                    children: selectedCatCol === null || selectedCatCol === void 0 ? void 0 : (ref2 = selectedCatCol.data) === null || ref2 === void 0 ? void 0 : ref2.name
                }),
                !isEssentialType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-h-[28px] tw-w-[1px] tw-bg-[#111C361F]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return handleClick("Sort");
                    },
                    className: " ".concat(!isEssentialType ? "tw-w-[132px] tw-items-center tw-justify-center" : "", " tw-flex tw-cursor-pointer tw-gap-[8px] tw-py-[12px]  tw-pl-[16px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "wb-sprite sort-filter"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-[15px] tw-font-normal tw-text-newBlack",
                            children: "Sort by"
                        })
                    ]
                })
            ]
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var selectedFilterInfo = props.selectedFilterInfo, selectedCatCol = props.selectedCatCol, isFilterAvailable = props.isFilterAvailable, isCollection = props.isCollection;
    var ref6 = (0,react.useState)(false), isFilterActive = ref6[0], setIsFilterActive = ref6[1];
    var ref7 = (0,react.useState)(false), showSortInMobile = ref7[0], setShowSortInMobile = ref7[1];
    var ref8 = (0,react.useState)(false), isSticky = ref8[0], setIsSticky = ref8[1];
    var ref9 = (0,react.useState)(false), showRef = ref9[0], setShowRef = ref9[1];
    var ref10 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref10.widgetContextState, isBuilder = _widgetContextState.isBuilder, pageStyle = _widgetContextState.pageStyle, globalStyle = _widgetContextState.globalStyle;
    var ref11 = (0,redux/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            sortType: state.catalogReducer.sortType,
            store: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store,
            headerRef: (ref1 = state.commonReducer) === null || ref1 === void 0 ? void 0 : ref1.headerRef
        };
    }), sortType = ref11.sortType, store = ref11.store, headerRef = ref11.headerRef;
    var catalog_items = (0,redux/* useSelector */.v9)(function(state) {
        return {
            catalog_items: state.catalogReducer.catalog_items
        };
    }).catalog_items;
    var isEssentialType = !(isFilterAvailable && isCollection);
    var mobileRef = (0,react.useRef)(null);
    var themeColor = isBuilder ? (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.color) === null || ref === void 0 ? void 0 : ref.themeColor) || (store === null || store === void 0 ? void 0 : (ref1 = store.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) || "" : store === null || store === void 0 ? void 0 : (ref3 = store.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color;
    var mobileLayout = pageStyle === null || pageStyle === void 0 ? void 0 : (ref5 = pageStyle.sortAndFilter) === null || ref5 === void 0 ? void 0 : ref5.layout_mobile;
    var isLayout1 = mobileLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE;
    var updatedSortList = isEssentialType ? constants/* ESSENTIAL_SORTING_OPTIONS */.l_ : constants/* SortList */.j;
    (0,react.useEffect)(function() {
        var ref;
        var container = isBuilder ? (ref = props.containerRef) === null || ref === void 0 ? void 0 : ref.current : window;
        var target = mobileRef.current;
        var handleScroll = function() {
            if (!container || !target) return;
            var targetRect = target.getBoundingClientRect();
            if (targetRect.top < 0) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        showRef,
        isFilterActive
    ]);
    (0,react.useEffect)(function() {
        setShowRef(true);
    }, []);
    var selectedFilterCount = (0,react.useMemo)(function() {
        var ref;
        var count = 0;
        (ref = Object.keys(selectedFilterInfo || {})) === null || ref === void 0 ? void 0 : ref.map(function(key) {
            var ref;
            count = count + ((ref = selectedFilterInfo[key]) === null || ref === void 0 ? void 0 : ref.length);
        });
        return count;
    }, [
        selectedFilterInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_FilterHeading, {
                            selectedCatCol: props === null || props === void 0 ? void 0 : props.selectedCatCol,
                            isCollection: props.isCollection
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            renderFilters(),
                            isSticky && scrollStateFilter()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: isFilterActive,
                style: {
                    bottom: 0
                },
                onClose: function() {
                    return setIsFilterActive(false);
                },
                children: showSortInMobile ? renderSortForMobile() : renderFilterForMobile()
            })
        ]
    });
};
/* harmony default export */ var SortAndFilter_SortAndFilterMobile = (SortAndFilterMobile);

// EXTERNAL MODULE: ./src/hooks/useTriggerChangeTopHeightMobile.js
var useTriggerChangeTopHeightMobile = __webpack_require__(302876);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/AdvanceCatalogMiddleBody.js
/* eslint-disable new-cap */ // eslint-disable-next-line no-undef

var ref = __webpack_require__(546431), motion = ref.motion, AnimatePresence = ref.AnimatePresence;






















function AdvanceCatalogMiddleBody() {
    var handleSortByClick = function handleSortByClick() {
        // simulates apply condition in Mobile when FilterDrawer is open
        if (isMobile && showFilterDrawer) {
            setShowFilterDrawer(!showFilterDrawer);
            setTimeout(function() {
                setShowFilterDrawerDelay(!showFilterDrawerDelay);
            }, 525);
            setMobilePrevFilterOption(filteredOptions);
            return;
        } else if (isMobile && showSortByDropDown) {
            setShowSortByDropDown(!showSortByDropDown);
            return;
        } else setShowSortByDropDown(!showSortByDropDown);
    };
    var getCorrectedFilterAppliedCounter = function getCorrectedFilterAppliedCounter() {
        var newFilteredAppliedCounter = 0;
        mobilePrevFilterOption && mobilePrevFilterOption.forEach(function(item) {
            var ref;
            !!(item === null || item === void 0 ? void 0 : (ref = item.sub_filter) === null || ref === void 0 ? void 0 : ref.length) && (item === null || item === void 0 ? void 0 : item.sub_filter.forEach(function(subFilterItem) {
                if (subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.is_selected) {
                    newFilteredAppliedCounter++;
                }
            }));
        });
        dispatch((0,catalog/* filtersCounter */.Ds)(newFilteredAppliedCounter, true));
    };
    var getFilterOptionSelectedArray = function getFilterOptionSelectedArray(localfilterOptions) {
        var selectedSubFilters = [];
        !!(localfilterOptions === null || localfilterOptions === void 0 ? void 0 : localfilterOptions.length) && localfilterOptions.forEach(function(filterOptionItem) {
            var ref;
            !!((ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && filterOptionItem.sub_filters.forEach(function(item) {
                (item === null || item === void 0 ? void 0 : item.is_selected) && selectedSubFilters.push(item === null || item === void 0 ? void 0 : item.name);
            });
        });
        return selectedSubFilters;
    };
    var isFilterOptionAsPrevious = /**
   * checks whether two array are equal or not
   * @param {*} prevFilterOptions FilterOption State in Mobile before Current Session
   * @param {*} currentFilterOptions FilterOption State in Current Session
   * @returns {boolean} if both arrays are same return true else false
   */ function isFilterOptionAsPrevious(prevFilterOptions, currentFilterOptions) {
        var prevSelectedSubFilters = getFilterOptionSelectedArray(prevFilterOptions);
        var currentSelectedSubFilters = getFilterOptionSelectedArray(currentFilterOptions);
        if (prevSelectedSubFilters.length === currentSelectedSubFilters.length) {
            return prevSelectedSubFilters.every(function(element, index) {
                if (element === currentSelectedSubFilters[index]) {
                    return true;
                }
                return false;
            });
        }
        return false;
    };
    var handleShowFilterDrawerAndClose = /**
   * when filter drawer close in mobile the checked states need to be reset
   * to previous state so does filterApplied counter
   * @returns {*}
   */ function handleShowFilterDrawerAndClose() {
        if (isMobile && showSortByDropDown) {
            showSortByDropDown && handleSortByClick();
            showFilterDrawer && setShowFilterDrawer(!showFilterDrawer);
            return;
        } else if (isMobile && showFilterDrawerDelay) {
            if (!isFilterOptionAsPrevious(mobilePrevFilterOption, filteredOptions)) getCorrectedFilterAppliedCounter();
            !!(mobilePrevFilterOption === null || mobilePrevFilterOption === void 0 ? void 0 : mobilePrevFilterOption.length) && dispatch((0,catalog/* saveFilteredOptions */.Pu)(mobilePrevFilterOption));
        }
        setShowFilterDrawer(!showFilterDrawer);
        setTimeout(function() {
            setShowFilterDrawerDelay(!showFilterDrawerDelay);
        }, 525);
    };
    var handleSortItemClick = function handleSortItemClick(e, sortItem) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        dispatch((0,catalog/* setSortType */.Td)(sortItem.type));
        (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
            sortTypeChanged: true
        });
        !isMobile && handleSortByClick();
    };
    var getNameFromSortType = function getNameFromSortType() {
        var ref;
        return (ref = constants/* SortList */.j && !!(constants/* SortList */.j === null || constants/* SortList */.j === void 0 ? void 0 : constants/* SortList.length */.j.length) && constants/* SortList.find */.j.find(function(item) {
            return item.type === sortType;
        })) === null || ref === void 0 ? void 0 : ref.name;
    };
    var renderFilterDrawer = function renderFilterDrawer() {
        return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLeftSectionContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                    handleShowFilterDrawer: handleShowFilterDrawerAndClose
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                handleShowFilterDrawer: handleShowFilterDrawerAndClose
            })
        });
    };
    var renderFilterDrawerDesktop = function renderFilterDrawerDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence, {
            children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    opacity: 0,
                    x: -100,
                    zIndex: 3
                },
                transition: {
                    duration: 0.5
                },
                animate: {
                    opacity: 1,
                    x: 0,
                    zIndex: 3
                },
                exit: {
                    opacity: 0,
                    x: -100,
                    zIndex: 3
                },
                children: renderFilterDrawer()
            }, "filterDrawer")
        });
    };
    var renderFilterDrawerMobile = function renderFilterDrawerMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence, {
            children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    opacity: 0,
                    x: 0,
                    zIndex: -1
                },
                transition: {
                    duration: 0.5
                },
                animate: {
                    opacity: 1,
                    x: 0,
                    zIndex: 3
                },
                exit: {
                    opacity: 0,
                    x: 0,
                    zIndex: -1
                },
                children: renderFilterDrawer()
            }, "filterDrawer")
        });
    };
    var renderLeftSection = function renderLeftSection() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isMobile ? renderFilterDrawerMobile() : renderFilterDrawerDesktop(),
                !(showFilterDrawer ? showFilterDrawer : showFilterDrawerDelay) && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
                    visibilty: "hidden"
                })
            ]
        });
    };
    var renderFilterCta = function renderFilterCta() {
        return (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCtaContainer, {
            id: "FilterCtaContainer",
            onClick: handleShowFilterDrawerAndClose,
            showFilterDrawer: isMobile ? false : showFilterDrawer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterIconContainer, {
                    children: isMobile ? isSortFilterOptionsActive ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterIcon/* MobileFilterIcon */.H, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterIcon/* MobileFilterIcon */.H, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterText, {
                    children: isMobile ? isSortFilterOptionsActive ? "Close" : "Filters" : "Filters"
                })
            ]
        });
    };
    var renderSortArrowIcon = function renderSortArrowIcon() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSortIconContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortIcon, {
                    rotate: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {})
                })
            ]
        });
    };
    var renderMobileSortByHeading = function renderMobileSortByHeading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortHeadingContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortHeadingText, {
                children: "Sort by"
            })
        });
    };
    var sortByDesktopText = function sortByDesktopText() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "flex flex-row",
            children: [
                "Sort by:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ml6px fw6 flex justify-center align-center",
                    children: getNameFromSortType()
                })
            ]
        });
    };
    var renderSortByCta = function renderSortByCta() {
        if (!(filterAppliedCounter || CollectionOrCategoryId)) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByCtaContainer, {
            onClick: handleSortByClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByTitle, {
                    storeInfo: store,
                    isApplyActive: isMobile && isSortFilterOptionsActive,
                    children: [
                        isMobile && (isSortFilterOptionsActive ? null : renderSortArrowIcon()),
                        isMobile ? isSortFilterOptionsActive ? "Apply" : "Sort by" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: sortByDesktopText()
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowContainer, {
                            showSortByDropDown: showSortByDropDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowSort/* DropDownArrowSort */.b, {})
                        })
                    ]
                }),
                showSortByDropDown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownContainer, {
                    children: [
                        isMobile && renderMobileSortByHeading(),
                        constants/* SortList.map */.j.map(function(sortItem) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownListElement, {
                                storeInfo: store,
                                onClick: function(e) {
                                    handleSortItemClick(e, sortItem);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownListInput, {
                                        checked: sortItem.type === sortType ? true : false,
                                        readOnly: true,
                                        type: "radio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownListLabel, {
                                        isSelected: sortItem.type === sortType ? true : false,
                                        className: "".concat(sortItem.type === sortType ? "!tw-text-newBlack" : ""),
                                        children: sortItem.name
                                    })
                                ]
                            }, "Sort-DropDown-list-".concat(sortItem.name));
                        })
                    ]
                })
            ]
        });
    };
    var SortAndFilterCtaTab = function SortAndFilterCtaTab() {
        if (isMobile && !showSortAndFilterMobileCta) return null;
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortFilterWrapper, {
            children: [
                renderFilterCta(),
                renderSortByCta()
            ]
        });
    };
    var renderCategoryItemList = function renderCategoryItemList() {
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyOverflow, {
            isMobile: isMobile,
            children: [
                SortAndFilterCtaTab(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCategoriesItems_AllCategoriesItems, {
                    showSortByDropDown: showSortByDropDown,
                    showFilterDrawer: showFilterDrawer
                })
            ]
        });
    };
    var renderSortAndFilteredItems = function renderSortAndFilteredItems() {
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyOverflow, {
            isMobile: isMobile,
            children: [
                SortAndFilterCtaTab(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilteredItems_SortAndFilteredItems, {
                    middleBodyContainerRef: middleBodyContainerRef,
                    showSortByDropDown: showSortByDropDown,
                    showFilterDrawer: showFilterDrawer
                })
            ]
        });
    };
    var renderMiddleBodyAnimated = function renderMiddleBodyAnimated() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isMobile ? renderMiddleSection() : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    x: 0
                },
                transition: {
                    duration: 0.5
                },
                animate: showFilterDrawer ? {
                    x: 0
                } : {},
                className: "tw-w-full",
                children: renderMiddleSection()
            }, "middleBodyAnimated")
        });
    };
    var renderMiddleSection = function renderMiddleSection() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleSection, {
            ref: middleBodyRef,
            children: showSortAndFilteredItems ? renderSortAndFilteredItems() : isCollection ? collectionCategoryItemsList() : renderCategoryItemList()
        });
    };
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), showSortByDropDown = ref[0], setShowSortByDropDown = ref[1];
    var ref1 = (0,react.useState)(false), showFilterDrawer = ref1[0], setShowFilterDrawer = ref1[1];
    var ref2 = (0,react.useState)(false), showFilterDrawerDelay = ref2[0], setShowFilterDrawerDelay = ref2[1];
    var ref3 = (0,react.useState)([]), mobilePrevFilterOption = ref3[0], setMobilePrevFilterOption = ref3[1];
    var ref4 = (0,react.useState)(false), isSortFilterOptionsActive = ref4[0], setIsSortFilterOptionsActive = ref4[1];
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType,
            filteredOptions: state.catalogReducer.filteredOptions,
            headerRef: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.headerRef
        };
    }), filterAppliedCounter = ref5.filterAppliedCounter, sortType = ref5.sortType, filteredOptions = ref5.filteredOptions, headerRef = ref5.headerRef;
    var ref6 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            collections: state.catalogReducer.collections,
            store: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store
        };
    }), store = ref6.store, collections = ref6.collections;
    var typeId = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)().typeId;
    var middleBodyRef = (0,react.useRef)();
    var middleBodyContainerRef = (0,react.useRef)();
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var isCollection = (collections === null || collections === void 0 ? void 0 : collections.length) ? true : false;
    var router = (0,next_router.useRouter)();
    var isHomepage = (router === null || router === void 0 ? void 0 : router.pathname) === "/";
    var CollectionOrCategoryId = isHomepage ? null : typeId;
    /**
   * checks when to show sortAndFilter Cta in mobile base on height
   * from bottom and top of middleBody.
   */ var showSortAndFilterMobileCta = (0,useTriggerChangeTopHeightMobile/* default */.Z)(middleBodyRef, isSortFilterOptionsActive, 150, 360);
    /** initial api call to get filterOptionList */ (0,useTriggerInitialFilterOptions/* default */.Z)(!CollectionOrCategoryId);
    (0,react.useEffect)(function() {
        setIsSortFilterOptionsActive(showSortByDropDown || showFilterDrawer);
    }, [
        showSortByDropDown,
        showFilterDrawer
    ]);
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,catalog/* filtersCounter */.Ds)(0, true));
        };
    }, []);
    /**
   * on mobile if filterDrawer is Active stop
   * Body from overflowing
   */ (0,react.useEffect)(function() {
        if (isSortFilterOptionsActive && isMobile) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            setTimeout(function() {
                middleBodyRef.current.scrollIntoView();
            }, 600);
        } else document.getElementsByTagName("body")[0].style.overflowY = "auto";
        return function() {
            document.getElementsByTagName("body")[0].style.overflowY = "auto";
        };
    }, [
        isSortFilterOptionsActive
    ]);
    (0,react.useEffect)(function() {
        if (isMobile && headerRef.current) {
            showFilterDrawer ? headerRef.current.style.display = "none" : headerRef.current.style.display = "";
        }
    }, [
        showFilterDrawer
    ]);
    var collectionCategoryItemsList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sortAndFilterCollection collection-category-items ".concat(isMobile ? "" : "tw-mx-[38px]"),
            children: [
                SortAndFilterCtaTab(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCollectionsItems_AllCollectionsItems, {
                    showFilterDrawer: showFilterDrawer,
                    showSortByDropDown: showSortByDropDown
                })
            ]
        });
    };
    var showSortAndFilteredItems = filterAppliedCounter || CollectionOrCategoryId ? !lodash_default().isNil(sortType) : false; // null or undefined are explicitly checked as sortType can be 0(Categories) also
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvMiddleBodyWrapper, {
        ref: middleBodyContainerRef,
        children: [
            renderLeftSection(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvMiddleBodyContainer, {
                children: renderMiddleBodyAnimated()
            })
        ]
    });
}
/* harmony default export */ var MiddleBody7_AdvanceCatalogMiddleBody = (AdvanceCatalogMiddleBody);

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/utils.tsx
var WidgetDnD_utils = __webpack_require__(844369);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/AdvanceCatalogMiddleBody1.js
// eslint-disable-next-line no-undef



var AdvanceCatalogMiddleBody1_ref = __webpack_require__(546431), AdvanceCatalogMiddleBody1_motion = AdvanceCatalogMiddleBody1_ref.motion, AdvanceCatalogMiddleBody1_AnimatePresence = AdvanceCatalogMiddleBody1_ref.AnimatePresence;



// import useTriggerChangeTopHeightMobile from '../../../../hooks/useTriggerChangeTopHeightMobile';




























function AdvanceCatalogMiddleBody1(props) {
    var getSelectedId = function getSelectedId() {
        var returnId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var ref, ref1;
        var ref2 = (pageStyle === null || pageStyle === void 0 ? void 0 : (ref = pageStyle.categoryCollectionData) === null || ref === void 0 ? void 0 : (ref1 = ref.listPresentation) === null || ref1 === void 0 ? void 0 : ref1.contentItems) || {}, _listItem = ref2.listItem, listItem = _listItem === void 0 ? [] : _listItem;
        var selectedCollCat = listItem === null || listItem === void 0 ? void 0 : listItem.find(function(item) {
            return item === null || item === void 0 ? void 0 : item.isVisible;
        });
        return selectedCollCat;
    };
    var handleSortByClick = function handleSortByClick() {
        // simulates apply condition in Mobile when FilterDrawer is open
        if (isMobile && showFilterDrawer) {
            setShowFilterDrawer(!showFilterDrawer);
            setTimeout(function() {
                setShowFilterDrawerDelay(!showFilterDrawerDelay);
            }, 525);
            setMobilePrevFilterOption(filteredOptions);
            return;
        } else if (isMobile && showSortByDropDown) {
            setShowSortByDropDown(!showSortByDropDown);
            setShowSortForMobile(!showSortForMobile);
            return;
        } else setShowSortByDropDown(!showSortByDropDown);
    };
    var getCorrectedFilterAppliedCounter = function getCorrectedFilterAppliedCounter() {
        var newFilteredAppliedCounter = 0;
        mobilePrevFilterOption && mobilePrevFilterOption.forEach(function(item) {
            var ref;
            !!(item === null || item === void 0 ? void 0 : (ref = item.sub_filter) === null || ref === void 0 ? void 0 : ref.length) && (item === null || item === void 0 ? void 0 : item.sub_filter.forEach(function(subFilterItem) {
                if (subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.is_selected) {
                    newFilteredAppliedCounter++;
                }
            }));
        });
        dispatch((0,catalog/* filtersCounter */.Ds)(newFilteredAppliedCounter, true));
    };
    var getFilterOptionSelectedArray = function getFilterOptionSelectedArray(localfilterOptions) {
        var selectedSubFilters = [];
        !!(localfilterOptions === null || localfilterOptions === void 0 ? void 0 : localfilterOptions.length) && localfilterOptions.forEach(function(filterOptionItem) {
            var ref;
            !!((ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && filterOptionItem.sub_filters.forEach(function(item) {
                (item === null || item === void 0 ? void 0 : item.is_selected) && selectedSubFilters.push(item === null || item === void 0 ? void 0 : item.name);
            });
        });
        return selectedSubFilters;
    };
    var isFilterOptionAsPrevious = /**
   * checks whether two array are equal or not
   * @param {*} prevFilterOptions FilterOption State in Mobile before Current Session
   * @param {*} currentFilterOptions FilterOption State in Current Session
   * @returns {boolean} if both arrays are same return true else false
   */ function isFilterOptionAsPrevious(prevFilterOptions, currentFilterOptions) {
        var prevSelectedSubFilters = getFilterOptionSelectedArray(prevFilterOptions);
        var currentSelectedSubFilters = getFilterOptionSelectedArray(currentFilterOptions);
        if (prevSelectedSubFilters.length === currentSelectedSubFilters.length) {
            return prevSelectedSubFilters.every(function(element, index) {
                if (element === currentSelectedSubFilters[index]) {
                    return true;
                }
                return false;
            });
        }
        return false;
    };
    var handleShowFilterDrawerAndClose = /**
   * when filter drawer close in mobile the checked states need to be reset
   * to previous state so does filterApplied counter
   * @returns {*}
   */ function handleShowFilterDrawerAndClose() {
        if (isMobile && showSortByDropDown) {
            showSortByDropDown && handleSortByClick();
            showFilterDrawer && setShowFilterDrawer(!showFilterDrawer);
            return;
        } else if (isMobile && showFilterDrawerDelay) {
            if (!isFilterOptionAsPrevious(mobilePrevFilterOption, filteredOptions)) getCorrectedFilterAppliedCounter();
            !!(mobilePrevFilterOption === null || mobilePrevFilterOption === void 0 ? void 0 : mobilePrevFilterOption.length) && dispatch((0,catalog/* saveFilteredOptions */.Pu)(mobilePrevFilterOption));
        }
        setShowFilterDrawer(!showFilterDrawer);
        setTimeout(function() {
            setShowFilterDrawerDelay(!showFilterDrawerDelay);
        }, 525);
    };
    var handleSortItemClick = function handleSortItemClick(e, sortItem) {
        var ref;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        dispatch((0,catalog/* fetchCatalogItemsByCategoryId */.Is)({
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            category_id: isBuilder ? selectedCatCol === null || selectedCatCol === void 0 ? void 0 : selectedCatCol.id : selectedCatCol === null || selectedCatCol === void 0 ? void 0 : (ref = selectedCatCol.data) === null || ref === void 0 ? void 0 : ref.id,
            category_type: (0,MiddleBody7_utils/* isCustomTag */.ve)(isBuilder ? selectedCatCol : selectedCatCol === null || selectedCatCol === void 0 ? void 0 : selectedCatCol.data),
            page_no: 1,
            storePrevitem: false,
            sort_type: sortItem === null || sortItem === void 0 ? void 0 : sortItem.type,
            items_per_page: (0,MiddleBody7_utils/* getPaginatedItemsPerPage */.vU)(gridAndPagination, isMobile)
        }));
        dispatch((0,catalog/* setSortType */.Td)(sortItem.type));
        (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
            sortTypeChanged: true
        });
        !isMobile && handleSortByClick();
    };
    var removeUnwantedFilter = /**
   *
   * @param {*} filterList
   * @returns New filter option list, after removing Collection/Category based on the route.
   */ function removeUnwantedFilter() {
        var filterList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (!filterList) {
            return filterList;
        }
        // Exclude collections by default - similar logic applied for older PLP widgets.( Refer <FilterComponent /> )
        var filtersToExclude = [
            FILTER_OPTIONS_SNF_WIDGET.COLLECTION
        ];
        // Exclude categories if the current page is categories.
        if (isTypeCategory) {
            filtersToExclude.push(FILTER_OPTIONS_SNF_WIDGET.CATEGORIES);
        }
        return filterList.filter(function(item) {
            return !filtersToExclude.includes(item === null || item === void 0 ? void 0 : item.name);
        });
    };
    var getNameFromSortType = function getNameFromSortType() {
        var ref;
        return (ref = updatedSortList && !!(updatedSortList === null || updatedSortList === void 0 ? void 0 : updatedSortList.length) && updatedSortList.find(function(item) {
            return item.type === sortType;
        })) === null || ref === void 0 ? void 0 : ref.name;
    };
    var renderFilterDrawer = function renderFilterDrawer() {
        return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLeftSectionContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                    handleShowFilterDrawer: handleShowFilterDrawerAndClose
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                handleShowFilterDrawer: handleShowFilterDrawerAndClose
            })
        });
    };
    var renderFilterDrawerDesktop = function renderFilterDrawerDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody1_AnimatePresence, {
            children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody1_motion.div, {
                initial: {
                    opacity: 0,
                    x: -100,
                    zIndex: 3
                },
                transition: {
                    duration: 0.5
                },
                animate: {
                    opacity: 1,
                    x: 0,
                    zIndex: 3
                },
                exit: {
                    opacity: 0,
                    x: -100,
                    zIndex: 3
                },
                children: renderFilterDrawer()
            }, "filterDrawer")
        });
    };
    var renderFilterDrawerMobile = function renderFilterDrawerMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody1_AnimatePresence, {
            children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody1_motion.div, {
                initial: {
                    opacity: 0,
                    x: 0,
                    zIndex: -1
                },
                transition: {
                    duration: 0.5
                },
                animate: {
                    opacity: 1,
                    x: 0,
                    zIndex: 3
                },
                exit: {
                    opacity: 0,
                    x: 0,
                    zIndex: -1
                },
                children: renderFilterDrawer()
            }, "filterDrawer")
        });
    };
    var renderLeftSection = function renderLeftSection() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isMobile ? renderFilterDrawerMobile() : renderFilterDrawerDesktop(),
                !(showFilterDrawer ? showFilterDrawer : showFilterDrawerDelay) && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
                    visibilty: "hidden"
                })
            ]
        });
    };
    var renderNewFilterLeftSection = function renderNewFilterLeftSection() {
        var isScrollView = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilter_SortAndFilter, {
            filterOption: removeUnwantedFilter(filteredOptions),
            showFilters: showFilterData,
            hideFilter: setShowFilterData,
            selectedFilterInfo: selectedFilterInfo,
            setSelectedFilterInfo: setSelectedFilterInfo,
            isViewMore: isViewMore,
            setIsViewMore: setIsViewMore,
            isScrollView: isScrollView
        });
    };
    var renderFilterCta = function renderFilterCta() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCtaContainer, {
            id: "FilterCtaContainer",
            onClick: handleShowFilterDrawerAndClose,
            showFilterDrawer: isMobile ? false : showFilterDrawer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterIconContainer, {
                    children: isMobile ? isSortFilterOptionsActive ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterIcon/* MobileFilterIcon */.H, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterIcon/* MobileFilterIcon */.H, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterText, {
                    children: isMobile ? isSortFilterOptionsActive ? "Close" : "Filters" : "Filters"
                })
            ]
        });
    };
    var renderSortArrowIcon = function renderSortArrowIcon() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSortIconContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortIcon, {
                    rotate: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {})
                })
            ]
        });
    };
    var renderMobileSortByHeading = function renderMobileSortByHeading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortHeadingContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortHeadingText, {
                children: "Sort by"
            })
        });
    };
    var sortByDesktopText = function sortByDesktopText() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "flex flex-row",
            children: [
                "Sort by:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ml6px fw6 flex justify-center align-center",
                    children: getNameFromSortType()
                })
            ]
        });
    };
    var newSortByDesktopText = function newSortByDesktopText() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: (0,_object_spread/* default */.Z)({}, getFilterTitleStyle(pageStyle, isMobile)),
            children: "Sort by: ".concat(getNameFromSortType())
        });
    };
    var renderSortByCta = function renderSortByCta() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByCtaContainer, {
            onClick: handleSortByClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByTitle, {
                    borderRadius: ctaRadius,
                    storeInfo: store,
                    isApplyActive: isMobile && isSortFilterOptionsActive,
                    children: [
                        isMobile && (isSortFilterOptionsActive ? null : renderSortArrowIcon()),
                        isMobile ? isSortFilterOptionsActive ? "Apply" : "Sort by" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: sortByDesktopText()
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowContainer, {
                            showSortByDropDown: showSortByDropDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowSort/* DropDownArrowSort */.b, {})
                        })
                    ]
                }),
                showSortByDropDown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownContainer, {
                    borderRadius: ctaRadius,
                    children: [
                        isMobile && renderMobileSortByHeading(),
                        updatedSortList.map(function(sortItem) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownListElement, {
                                storeInfo: themeColor,
                                onClick: function(e) {
                                    handleSortItemClick(e, sortItem);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownListInput, {
                                        checked: sortItem.type === sortType ? true : false,
                                        type: "radio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownListLabel, {
                                        isSelected: sortItem.type === sortType ? true : false,
                                        children: sortItem.name
                                    })
                                ]
                            }, "Sort-DropDown-list-".concat(sortItem.name));
                        })
                    ]
                })
            ]
        });
    };
    var renderSortByCtaNew = function renderSortByCtaNew() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByCtaContainer, {
            onClick: handleSortByClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByTitle, {
                    storeInfo: themeColor,
                    style: {
                        borderRadius: !isLayout2 ? Number(borderRadiusVal) : ""
                    },
                    isApplyActive: isMobile && isSortFilterOptionsActive,
                    className: (0,bundle_mjs/* twMerge */.m6)(isLayout2 ? "!tw-border-none !tw-px-[0px]" : "!tw-px-[20px]", "tw-flex tw-w-max !tw-min-w-[0px] tw-items-center tw-justify-center !tw-py-[8px]"),
                    children: [
                        renderSortArrowIcon(),
                        isMobile ? isSortFilterOptionsActive ? "Apply" : "Sort by" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: newSortByDesktopText()
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowContainer, {
                            className: "!tw-ml-[6px]",
                            showSortByDropDown: showSortByDropDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowSort/* DropDownArrowSort */.b, {})
                        })
                    ]
                }),
                showSortByDropDown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownContainer, {
                    borderRadius: ctaRadius,
                    className: "!tw-z-[100] tw-ml-[0px] tw-flex tw-flex-col tw-gap-[16px] tw-px-[16px] tw-py-[20px]",
                    children: [
                        isMobile && renderMobileSortByHeading(),
                        updatedSortList.map(function(sortItem) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownListElement, {
                                className: " !tw-mb-[0px] !tw-ml-[0px] tw-w-[220px]",
                                storeInfo: themeColor,
                                onClick: function(e) {
                                    handleSortItemClick(e, sortItem);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownListInput, {
                                        checked: sortItem.type === sortType ? true : false,
                                        type: "radio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: (0,_object_spread/* default */.Z)({}, getFilterOptionStyle(pageStyle, isMobile)),
                                        className: "".concat(sortItem.type === sortType ? "!tw-font-bold !tw-text-newBlack" : "!tw-font-normal", " tw-ml-[8px]"),
                                        children: sortItem.name
                                    })
                                ]
                            }, "Sort-DropDown-list-".concat(sortItem.name));
                        })
                    ]
                })
            ]
        });
    };
    var renderNewFilterCta = function renderNewFilterCta() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                borderRadius: Number(borderRadiusVal)
            },
            onClick: function() {
                return setShowFilterData(true);
            },
            className: "tw-flex tw-cursor-pointer tw-items-center tw-gap-[10px] tw-border tw-border-solid tw-border-[#111C361F] tw-px-[20px] tw-py-[8px]",
            children: [
                filterIcon(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (0,_object_spread/* default */.Z)({}, getFilterTitleStyle(pageStyle, isMobile)),
                    children: "Filters"
                })
            ]
        });
    };
    var renderSortFilterWrapper = function renderSortFilterWrapper() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortFilterWrapper, {
            ref: sortAndFilterRef,
            className: "tw-flex ".concat(isLayout1 ? "!tw-items-center" : "!tw-items-start", " ").concat(isLayout2 ? "tw-z-1 tw-sticky tw-top-[50px]" : ""),
            children: [
                isLayout3 && filteredOptions && renderNewFilterCta(),
                isLayout3 && !filteredOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                isLayout2 && renderNewFilterLeftSection(),
                isLayout1 && !isHeadingTypeImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_FilterHeading, {
                    selectedCatCol: selectedCatCol,
                    isCollection: isCollection
                }),
                isLayout1 && isHeadingTypeImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                renderSortByCtaNew()
            ]
        });
    };
    var renderSortFilterWrapperScroll = function renderSortFilterWrapperScroll() {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SortFilterWrapper, {
            style: {
                top: isBuilder ? (headerRef === null || headerRef === void 0 ? void 0 : (ref = headerRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) + 66 : 0,
                margin: "0 -16px",
                width: isBuilder ? middleBodyContainerRef === null || middleBodyContainerRef === void 0 ? void 0 : (ref1 = middleBodyContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth : "100%"
            },
            className: "tw-fixed !tw-z-[100] tw-flex !tw-items-start tw-bg-white",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    maxWidth: (middleBodyContainerRef === null || middleBodyContainerRef === void 0 ? void 0 : (ref2 = middleBodyContainerRef.current) === null || ref2 === void 0 ? void 0 : ref2.clientWidth) > 1468 ? 1468 : (middleBodyContainerRef === null || middleBodyContainerRef === void 0 ? void 0 : (ref3 = middleBodyContainerRef.current) === null || ref3 === void 0 ? void 0 : ref3.clientWidth) - 32
                },
                className: "!tw-z-[100] tw-ml-[16px] tw-flex tw-w-[100%] tw-items-start tw-justify-between tw-border-b tw-border-solid tw-border-[#111C361F] tw-py-[16px]",
                children: [
                    isLayout2 && renderNewFilterLeftSection(true),
                    renderSortByCtaNew()
                ]
            })
        });
    };
    var sortAndFilterCtaTab = function sortAndFilterCtaTab() {
        var showFullWidthHeading = isLayout3 || isLayout2;
        // if (isMobile && !showSortAndFilterMobileCta) return null;
        return isComponentMounted && (isOldLayoutSelected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortFilterWrapper, {
            className: " !tw-z-10 ",
            children: [
                (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) > 0 && renderFilterCta(),
                (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                renderSortByCta()
            ]
        }) : !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(showFullWidthHeading ? "tw-flex tw-flex-col tw-gap-[36px]" : ""),
            children: [
                (isLayout3 || isLayout2 || isHeadingTypeImage && desktopLayout !== Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_FilterHeading, {
                    selectedCatCol: selectedCatCol,
                    isCollection: isCollection
                }),
                renderSortFilterWrapper(),
                isSticky && isLayout2 && renderSortFilterWrapperScroll()
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilter_SortAndFilterMobile, {
            filterOption: removeUnwantedFilter(filteredOptions),
            showFilters: showFilterData,
            isCollection: isCollection,
            hideFilter: setShowFilterData,
            selectedCatCol: selectedCatCol,
            containerRef: props === null || props === void 0 ? void 0 : props.widgetRef,
            isFilterAvailable: isFilterAvailable,
            handleSortItemClick: handleSortItemClick,
            selectedFilterInfo: selectedFilterInfo,
            setSelectedFilterInfo: setSelectedFilterInfo,
            isViewMore: isViewMore,
            setIsViewMore: setIsViewMore
        }));
    };
    var renderCategoryItemList = function renderCategoryItemList() {
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBodyOverflow, {
            isMobile: isMobile,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCategoriesItems_AllCategoriesItems, {
                showSortByDropDown: showSortByDropDown,
                showFilterDrawer: showFilterDrawer,
                comingFromAdvCatlog: true,
                selectedId: isBuilder ? selectedCatCol === null || selectedCatCol === void 0 ? void 0 : selectedCatCol.id : typeId
            })
        });
    };
    var renderSortAndFilteredItems = function renderSortAndFilteredItems() {
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBodyOverflow, {
            isMobile: isMobile,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilteredItems_SortAndFilteredItems, {
                middleBodyContainerRef: middleBodyContainerRef,
                showSortByDropDown: showSortByDropDown,
                showFilterDrawer: showFilterDrawer,
                selectedId: selectedCatCol === null || selectedCatCol === void 0 ? void 0 : selectedCatCol.id,
                isCollection: isCollection
            })
        });
    };
    var renderMiddleBodyAnimated = function renderMiddleBodyAnimated() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isMobile ? renderMiddleSection() : /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody1_motion.div, {
                initial: {
                    x: 0
                },
                transition: {
                    duration: 0.5
                },
                animate: showFilterDrawer ? {
                    x: 0
                } : {},
                className: "tw-w-full",
                children: renderMiddleSection()
            }, "middleBodyAnimated")
        });
    };
    var renderMiddleSection = function renderMiddleSection() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleSection, {
            ref: middleBodyRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-relative",
                children: [
                    sortAndFilterCtaTab(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(isMobile ? "tw-mt-[4px]" : "tw-mt-[40px]"),
                        children: filterAppliedCounter || sortType || CollectionOrCategoryId || (selectedCatCol === null || selectedCatCol === void 0 ? void 0 : selectedCatCol.id) ? !(isCollection && isFilterAvailable) ? renderCategoryItemList() : renderSortAndFilteredItems() : isCollection ? collectionCategoryItemsList() : renderCategoryItemList()
                    })
                ]
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref5 = (0,react.useState)(false), showSortByDropDown = ref5[0], setShowSortByDropDown = ref5[1];
    var ref6 = (0,react.useState)(false), showFilterDrawer = ref6[0], setShowFilterDrawer = ref6[1];
    var ref7 = (0,react.useState)(false), showFilterDrawerDelay = ref7[0], setShowFilterDrawerDelay = ref7[1];
    var ref8 = (0,react.useState)([]), mobilePrevFilterOption = ref8[0], setMobilePrevFilterOption = ref8[1];
    var ref9 = (0,react.useState)(false), showSortForMobile = ref9[0], setShowSortForMobile = ref9[1];
    var ref10 = (0,react.useState)(false), isSortFilterOptionsActive = ref10[0], setIsSortFilterOptionsActive = ref10[1];
    var ref11 = (0,react.useState)(false), showFilterData = ref11[0], setShowFilterData = ref11[1];
    var ref12 = (0,react.useState)(false), isSticky = ref12[0], setIsSticky = ref12[1];
    var ref13 = (0,react.useState)(false), showRef = ref13[0], setShowRef = ref13[1];
    var sortAndFilterRef = (0,react.useRef)(null);
    var ref14 = (0,react.useState)(true), isViewMore = ref14[0], setIsViewMore = ref14[1];
    var ref15 = (0,react.useState)({}), selectedFilterInfo = ref15[0], setSelectedFilterInfo = ref15[1];
    var ref16 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref16.widgetContextState, isBuilder = _widgetContextState.isBuilder, pageStyle = _widgetContextState.pageStyle, globalStyle = _widgetContextState.globalStyle, setWidgetsByRoute = ref16.widgetContextActions.setWidgetsByRoute;
    var ref17;
    var ref18 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1, ref2;
        return {
            categories: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.categories,
            collections: state.catalogReducer.collections,
            productTags: (ref17 = (ref1 = state.catalogReducer) === null || ref1 === void 0 ? void 0 : ref1.productTags) !== null && ref17 !== void 0 ? ref17 : [],
            store: (ref2 = state.storeReducer) === null || ref2 === void 0 ? void 0 : ref2.store,
            jsonWidgetsReducer: state.jsonWidgetsReducer
        };
    }), store = ref18.store, collections = ref18.collections, categories = ref18.categories, productTags = ref18.productTags, jsonWidgetsReducer = ref18.jsonWidgetsReducer;
    var ref19 = pageStyle || {}, _gridAndPagination = ref19.gridAndPagination, gridAndPagination = _gridAndPagination === void 0 ? {} : _gridAndPagination;
    var ref20 = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)(), typeId = ref20.typeId, isTypeCategory = ref20.isTypeCategory, isTypeTags = ref20.isTypeTags;
    var themeColor = isBuilder ? {
        theme: {
            colors: {
                primary_color: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.color) === null || ref === void 0 ? void 0 : ref.themeColor) || (store === null || store === void 0 ? void 0 : (ref1 = store.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color)
            }
        }
    } : store;
    var boxRadius = buttonStyle(globalStyle, "", true);
    var borderRadiusVal = globalStyleValue(boxRadius === null || boxRadius === void 0 ? void 0 : boxRadius.borderRadius);
    var CollectionOrCategoryId = isBuilder ? selectedCatCol === null || selectedCatCol === void 0 ? void 0 : selectedCatCol.id : typeId;
    var selectedCollectionCategory = (0,react.useMemo)(function() {
        if (isTypeCategory || isTypeTags) {
            // if shop present in route
            var selectedCategory = (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories)).find(function(categoryItem) {
                return (categoryItem === null || categoryItem === void 0 ? void 0 : categoryItem.id) == typeId // then fetch from store
                ;
            });
            return selectedCategory;
        } else {
            var selectedCollection = collections.find(function(collection) {
                return (collection === null || collection === void 0 ? void 0 : collection.id) == typeId // then fetch from store
                ;
            });
            return selectedCollection;
        }
    }, [
        CollectionOrCategoryId
    ]);
    var middleBodyRef = (0,react.useRef)();
    var middleBodyContainerRef = (0,react.useRef)();
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var isCollection = (collections === null || collections === void 0 ? void 0 : collections.length) ? true : false;
    var selectedCatCol = isBuilder ? getSelectedId() : {
        data: selectedCollectionCategory
    };
    var ref21 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType,
            filteredOptions: state.catalogReducer.filteredOptions,
            headerRef: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.headerRef
        };
    }), filterAppliedCounter = ref21.filterAppliedCounter, sortType = ref21.sortType, filteredOptions = ref21.filteredOptions, headerRef = ref21.headerRef;
    var isFilterAvailable = (0,react.useMemo)(function() {
        return Array.isArray(filteredOptions) && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) >= 0;
    }, [
        filteredOptions
    ]);
    var desktopLayout = (0,react.useMemo)(function() {
        var ref;
        return pageStyle === null || pageStyle === void 0 ? void 0 : (ref = pageStyle.sortAndFilter) === null || ref === void 0 ? void 0 : ref.layout_desktop;
    }, [
        pageStyle
    ]);
    var isLayout1 = desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE;
    var isLayout2 = desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO;
    var isLayout3 = desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE;
    var currentWidgetType = isCollection ? pageStyle === null || pageStyle === void 0 ? void 0 : pageStyle.caligraphyCollection : pageStyle === null || pageStyle === void 0 ? void 0 : pageStyle.caligraphyCategory;
    var isHeadingTypeImage = (currentWidgetType === null || currentWidgetType === void 0 ? void 0 : currentWidgetType.heading_type) === HEADING_TYPE_IMAGE;
    var isBannerFullWidth = currentWidgetType === null || currentWidgetType === void 0 ? void 0 : currentWidgetType.isBannerFullWidth;
    var isOldLayoutSelected = (0,react.useMemo)(function() {
        return desktopLayout === Testimonials_Constants/* COMMON_LAYOUT_TYPE.ZERO */.o_.ZERO || !desktopLayout || !pageStyle;
    }, [
        desktopLayout,
        pageStyle
    ]);
    var isEssential = !(isCollection && isFilterAvailable);
    var updatedSortList = isEssential ? constants/* ESSENTIAL_SORTING_OPTIONS */.l_ : constants/* SortList */.j;
    var ctaRadius = Math.min((0,WidgetDnD_utils.extractNumberFromString)(globalStyle === null || globalStyle === void 0 ? void 0 : (ref3 = globalStyle.buttons) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.style) === null || ref4 === void 0 ? void 0 : ref4.borderRadius), 12);
    /**
   * checks when to show sortAndFilter Cta in mobile base on height
   * from bottom and top of middleBody.
   */ // const showSortAndFilterMobileCta = useTriggerChangeTopHeightMobile(
    //   middleBodyRef,
    //   isSortFilterOptionsActive,
    //   150,
    //   360
    // );
    (0,useTriggerInitialFilterOptions/* default */.Z)(!CollectionOrCategoryId);
    (0,react.useEffect)(function() {
        var ref;
        var container = isBuilder ? (ref = props.widgetRef) === null || ref === void 0 ? void 0 : ref.current : window;
        var target = sortAndFilterRef.current;
        var handleScroll = function() {
            if (!container || !target) return;
            var targetRect = target.getBoundingClientRect();
            if (targetRect.top + target.clientHeight < 0) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        showRef
    ]);
    (0,react.useEffect)(function() {
        setShowRef(true);
    }, []);
    (0,react.useEffect)(function() {
        setIsSortFilterOptionsActive(showSortByDropDown || showFilterDrawer);
    }, [
        showSortByDropDown,
        showFilterDrawer
    ]);
    (0,react.useEffect)(function() {
        if (isEssential && !isOldLayoutSelected) {
            dispatch((0,catalog/* setSortType */.Td)(constants/* ESSENTIAL_SORTING_OPTIONS.0.type */.l_[0].type));
        } else {
            dispatch((0,catalog/* setSortType */.Td)(constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES));
        }
    }, [
        isOldLayoutSelected
    ]);
    // This sets new builder's sort & filter widget into context
    (0,react.useEffect)(function() {
        if (!isBuilder) {
            var payload = {
                routeName: "Collection",
                routeConfigs: {
                    widgets: jsonWidgetsReducer.widgets,
                    jsonPageWidgetSchema: jsonWidgetsReducer.jsonPageWidgetData,
                    style: jsonWidgetsReducer.pageStyle
                }
            };
            setWidgetsByRoute(payload);
        }
    }, []);
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,catalog/* filtersCounter */.Ds)(0, true));
        };
    }, []);
    /**
   * on mobile if filterDrawer is Active stop
   * Body from overflowing
   */ (0,react.useEffect)(function() {
        if (isSortFilterOptionsActive && isMobile) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            setTimeout(function() {
                middleBodyRef.current.scrollIntoView();
            }, 600);
        } else document.getElementsByTagName("body")[0].style.overflowY = "auto";
        return function() {
            document.getElementsByTagName("body")[0].style.overflowY = "auto";
        };
    }, [
        isSortFilterOptionsActive
    ]);
    (0,react.useEffect)(function() {
        if (isMobile && headerRef.current) {
            showFilterDrawer ? headerRef.current.style.display = "none" : headerRef.current.style.display = "";
        }
    }, [
        showFilterDrawer
    ]);
    var collectionCategoryItemsList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "sortAndFilterCollection collection-category-items ".concat(isMobile ? "" : "mr76px"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCollectionsItems_AllCollectionsItems, {
                showFilterDrawer: showFilterDrawer,
                showSortByDropDown: showSortByDropDown
            })
        });
    };
    if (isOldLayoutSelected) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody7_AdvanceCatalogMiddleBody, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: isHeadingTypeImage && !isBannerFullWidth ? {
            paddingTop: 24
        } : {},
        children: [
            isLayout1 && isHeadingTypeImage && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_FilterHeading, {
                selectedCatCol: selectedCatCol,
                isCollection: isCollection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvMiddleBodyWrapper, {
                className: "!tw-mt-[0px] ".concat(isLayout1 && !isMobile ? "!tw-pt-[68px]" : ""),
                ref: middleBodyContainerRef,
                children: [
                    isOldLayoutSelected ? renderLeftSection() : desktopLayout !== Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO && !isMobile ? renderNewFilterLeftSection() : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvMiddleBodyContainer, {
                        children: renderMiddleBodyAnimated()
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var MiddleBody7_AdvanceCatalogMiddleBody1 = (AdvanceCatalogMiddleBody1);


/***/ }),

/***/ 391612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FilterDrawer_FilterDrawer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconGrey.js
var CloseIconGrey = __webpack_require__(273467);
;// CONCATENATED MODULE: ./src/assets/svgExports/ColoredRectangle.js

function ColoredRectangle(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            y: "0.00390625",
            width: "18",
            height: "18",
            fill: (props === null || props === void 0 ? void 0 : props.color) ? props === null || props === void 0 ? void 0 : props.color : "none"
        })
    });
}

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/utils.js
var utils = __webpack_require__(708710);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterComponent/FilterComponent.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n  margin-left: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #eaeaea;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 14px;\n  overflow: hidden;\n  white-space: nowrap;\n  align-items: center;\n  text-overflow: ellipsis;\n  > input {\n    transform: scale(1.25);\n  }\n  > label {\n    max-width: 200px;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 14px;\n  cursor: pointer;\n  font-weight: 300;\n  font-size: 14px;\n  margin-left: 18px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  margin-top: 2px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  font-weight: 300;\n  font-size: 14px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background: #f7f7f7;\n  min-height: 90vh;\n  border-right: 1px solid #ededed;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 32vw;\n  padding: 16px;\n  ",
        ";\n  border-bottom: 1px solid #ededed;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction column;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction row;\n  margin-top: 20px;\n  align-items: center;\n   > input {\n    transform: scale(1.25);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var FilterComponentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentContainer",
    componentId: "sc-18ce1c48-0"
})(_templateObject());
var FilterComponentHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentHeading",
    componentId: "sc-18ce1c48-1"
})(_templateObject1());
var FilterComponentListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentListContainer",
    componentId: "sc-18ce1c48-2"
})(_templateObject2());
var FilterComponentListElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentListElement",
    componentId: "sc-18ce1c48-3"
})(_templateObject3());
var FilterComponentViewMore = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentViewMore",
    componentId: "sc-18ce1c48-4"
})(_templateObject4(), (0,getThemeColor/* getThemeColor */.p)());
var FilterColoredComponent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterColoredComponent",
    componentId: "sc-18ce1c48-5"
})(_templateObject5());
var FilterComponentText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentText",
    componentId: "sc-18ce1c48-6"
})(_templateObject6());
var FilterComponentMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileContainer",
    componentId: "sc-18ce1c48-7"
})(_templateObject7(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.loader) ? "pointer-events: none" : "";
});
var FilterComponentMobileHeadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileHeadingContainer",
    componentId: "sc-18ce1c48-8"
})(_templateObject8());
var FilterComponentMobileHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileHeading",
    componentId: "sc-18ce1c48-9"
})(_templateObject9(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) && "background : #FFFFFF";
});
var FilterComponentMobileHeadingText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileHeadingText",
    componentId: "sc-18ce1c48-10"
})(_templateObject10());
var FilterComponentMobileRightContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileRightContainer",
    componentId: "sc-18ce1c48-11"
})(_templateObject11());
var FilterComponentMobileInput = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileInput",
    componentId: "sc-18ce1c48-12"
})(_templateObject12());

// EXTERNAL MODULE: ./src/containers/Collections/useGetTypeIdFromCanonicalDataStore.js
var useGetTypeIdFromCanonicalDataStore = __webpack_require__(130553);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterComponent/FilterComponent.js










var MAX_ITEMS_SHOW_LIMIT = 5;
function FilterComponent(props) {
    var setSelectedFilter = function setSelectedFilter() {
        var newSelectedFilterForMobile = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.find(function(item) {
            return item.name === (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.name);
        });
        newSelectedFilterForMobile && setSelectedMobileFilter(newSelectedFilterForMobile);
    };
    var getFilterType = function getFilterType() {
        if (isTypeCategory) return 2;
        else if (isTypeCollection) return 1;
        return;
    };
    var handleViewMoreClick = function handleViewMoreClick(ListElement) {
        var length = (ListElement === null || ListElement === void 0 ? void 0 : ListElement.length) ? ListElement === null || ListElement === void 0 ? void 0 : ListElement.length : ListElement;
        setShowItemsLimit(length);
    };
    var handleSelectedMobileFilter = function handleSelectedMobileFilter(itemName) {
        var newSelectedFilterForMobile = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.find(function(item) {
            return item.name === itemName;
        });
        newSelectedFilterForMobile && setSelectedMobileFilter(newSelectedFilterForMobile);
    };
    var handleCheckboxClick = /**
   * set is_selected value for sub_filter and changes filterApplied counter and saves
   * new filterOptions in reducer.
   * @param {*} e event on checkbox
   * @param {*} filterOptionName the name of filter option that is currently shown
   * @param {*} subFilterName the name of subfilter that is checked/unchecked by user.
   */ function handleCheckboxClick(e, filterOptionName, subFilterName) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        var tempFilterOptions = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.slice(filteredOptions, filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length);
        for(var i = 0; i < (tempFilterOptions === null || tempFilterOptions === void 0 ? void 0 : tempFilterOptions.length); i++){
            var ref;
            if (filterOptionName === ((ref = tempFilterOptions[i]) === null || ref === void 0 ? void 0 : ref.name)) {
                var ref1, ref2;
                for(var j = 0; j < ((ref1 = tempFilterOptions[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sub_filters) === null || ref2 === void 0 ? void 0 : ref2.length); j++){
                    var ref3;
                    if (subFilterName === ((ref3 = tempFilterOptions[i].sub_filters[j]) === null || ref3 === void 0 ? void 0 : ref3.name)) {
                        e.target.checked ? tempFilterOptions[i].sub_filters[j]["is_selected"] = true : tempFilterOptions[i].sub_filters[j]["is_selected"] = false;
                        break;
                    }
                }
            }
        }
        setToggleClick(!toggleClick);
        var filterCounter = e.target.checked ? constants/* FILTER_COUNTER_OPTIONS.INC */.zO.INC : constants/* FILTER_COUNTER_OPTIONS.DEC */.zO.DEC;
        dispatch((0,catalog/* filtersCounter */.Ds)(filterCounter));
        dispatch((0,catalog/* saveFilteredOptions */.Pu)(tempFilterOptions));
        (0,utils/* setMB7SortAndFilterConfig */.lr)({
            filterAppliedCounterChanged: true
        });
    };
    var renderViewMore = function renderViewMore(ListElement) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentViewMore, {
            onClick: function() {
                handleViewMoreClick(ListElement);
            },
            children: [
                "+ ",
                (ListElement === null || ListElement === void 0 ? void 0 : ListElement.length) - MAX_ITEMS_SHOW_LIMIT,
                " more"
            ]
        });
    };
    var renderViewLess = function renderViewLess(ListElement) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentViewMore, {
            onClick: function() {
                handleViewMoreClick(ListElement);
            },
            children: "View Less"
        });
    };
    var getTotalItemsCheckCount = function getTotalItemsCheckCount(filterOptionItem) {
        var ref;
        var totalCheckedCount = 0;
        !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.sub_filters) && !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : (ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && (filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.sub_filters.forEach(function(item) {
            item.is_selected && totalCheckedCount++;
        }));
        return totalCheckedCount;
    };
    var removeCollectionOrCategoryFromPLP = function removeCollectionOrCategoryFromPLP(filterType) {
        if ((props === null || props === void 0 ? void 0 : props.hideCollectionFilter) && filterType === 1) {
            return false;
        }
        if ((props === null || props === void 0 ? void 0 : props.hideCategoryFilter) && filterType === 2) {
            return false;
        }
        if ((props === null || props === void 0 ? void 0 : props.hideTags) && filterType === 3) {
            return false;
        }
        if (isTypeCategory && filterType === 2) {
            return false;
        } else if (isTypeCollection && filterType === 1) {
            return false;
        }
        return true;
    };
    var renderMobileFilterComponent = function renderMobileFilterComponent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileContainer, {
            loader: filterOptionLoader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileHeadingContainer, {
                    children: !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function(filterOptionItem) {
                        var ref;
                        return !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : (ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && removeCollectionOrCategoryFromPLP(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileHeading, {
                            isSelected: (filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.name) === (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.name),
                            onClick: function() {
                                handleSelectedMobileFilter(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.name);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileHeadingText, {
                                children: [
                                    filterOptionItem.name,
                                    !!getTotalItemsCheckCount(filterOptionItem) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw3 ml8px",
                                        children: "(".concat(getTotalItemsCheckCount(filterOptionItem), ")")
                                    })
                                ]
                            })
                        }, "".concat(filterOptionItem.name).concat(filterOptionItem.type));
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileRightContainer, {
                    children: (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.sub_filters) && selectedMobileFilter.sub_filters.map(function(item) {
                        return removeCollectionOrCategoryFromPLP(selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.type) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileInput, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    className: "ml24px pointer",
                                    checked: item === null || item === void 0 ? void 0 : item.is_selected,
                                    id: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    onClick: function(e) {
                                        return handleCheckboxClick(e, selectedMobileFilter.name, item.name);
                                    }
                                }),
                                selectedMobileFilter.name === constants/* COLOR_FILTER_OPTION */.uh && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    className: "pointer ml10px mt2px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredRectangle, {
                                        color: item === null || item === void 0 ? void 0 : item.colour_code
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    className: "pointer ml10px fw3 f14px",
                                    children: item.name
                                })
                            ]
                        }, "subFilter-".concat(item === null || item === void 0 ? void 0 : item.name, "-").concat(item === null || item === void 0 ? void 0 : item.id));
                    })
                })
            ]
        });
    };
    var renderDesktopFilterComponent = function renderDesktopFilterComponent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function(filterOption) {
                var ref, ref1, ref2, ref3;
                return removeCollectionOrCategoryFromPLP(filterOption === null || filterOption === void 0 ? void 0 : filterOption.type) && !!(filterOption === null || filterOption === void 0 ? void 0 : (ref = filterOption.sub_filters) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentHeading, {
                            children: [
                                filterOption.name,
                                !!getTotalItemsCheckCount(filterOption) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "fw3 ml8px",
                                    children: "(".concat(getTotalItemsCheckCount(filterOption), ")")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentListContainer, {
                            children: [
                                filterOption === null || filterOption === void 0 ? void 0 : (ref1 = filterOption.sub_filters) === null || ref1 === void 0 ? void 0 : ref1.slice(0, showItemsLimit).map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentListElement, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                className: "ml4px pointer",
                                                checked: item === null || item === void 0 ? void 0 : item.is_selected,
                                                id: "".concat(filterOption.name, "-").concat(item.name),
                                                onClick: function(e) {
                                                    return handleCheckboxClick(e, filterOption.name, item.name);
                                                }
                                            }),
                                            filterOption.name === constants/* COLOR_FILTER_OPTION */.uh && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "".concat(filterOption.name, "-").concat(item.name),
                                                className: "pointer ml10px mt2px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredRectangle, {
                                                    color: item === null || item === void 0 ? void 0 : item.colour_code
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "".concat(filterOption.name, "-").concat(item.name),
                                                className: "pointer ml10px fw3 f14px",
                                                children: item.name
                                            })
                                        ]
                                    }, "".concat(filterOption.name, "-").concat(item.name, "-filterOption-subFilters"));
                                }),
                                (filterOption === null || filterOption === void 0 ? void 0 : (ref2 = filterOption.sub_filters) === null || ref2 === void 0 ? void 0 : ref2.length) > showItemsLimit && renderViewMore(filterOption === null || filterOption === void 0 ? void 0 : filterOption.sub_filters),
                                !!((filterOption === null || filterOption === void 0 ? void 0 : (ref3 = filterOption.sub_filters) === null || ref3 === void 0 ? void 0 : ref3.length) === showItemsLimit && showItemsLimit > MAX_ITEMS_SHOW_LIMIT) && renderViewLess(MAX_ITEMS_SHOW_LIMIT)
                            ]
                        })
                    ]
                }, "".concat(filterOption.name, "-filterOption")) : null;
            }))
        });
    };
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(MAX_ITEMS_SHOW_LIMIT), showItemsLimit = ref[0], setShowItemsLimit = ref[1];
    var ref1 = (0,react.useState)({}), selectedMobileFilter = ref1[0], setSelectedMobileFilter = ref1[1];
    var ref2 = (0,react.useState)(false), toggleClick = ref2[0], setToggleClick = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            filteredOptions: state.catalogReducer.filteredOptions,
            filterOptionLoader: state.commonReducer.filterOptionLoader,
            hideFiltersCategoryAndCollection: state.commonReducer.hideFiltersCategoryAndCollection
        };
    }), filteredOptions = ref3.filteredOptions, filterOptionLoader = ref3.filterOptionLoader, hideFiltersCategoryAndCollection = ref3.hideFiltersCategoryAndCollection;
    (0,react.useEffect)(function() {
        !!filteredOptions && !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && isMobile && hideFiltersCategoryAndCollection ? setSelectedMobileFilter(filteredOptions[2] || {}) : removeCollectionOrCategoryFromPLP(getFilterType()) ? setSelectedMobileFilter(filteredOptions[0] || {}) : setSelectedMobileFilter(filteredOptions[1] || {});
    }, [
        hideFiltersCategoryAndCollection
    ]);
    (0,react.useEffect)(function() {
        if (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) {
            setSelectedFilter();
        }
    }, [
        toggleClick
    ]);
    (0,react.useEffect)(function() {
        setSelectedFilter();
    }, [
        filteredOptions
    ]);
    var ref4 = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)(), isTypeCategory = ref4.isTypeCategory, isTypeCollection = ref4.isTypeCollection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? renderMobileFilterComponent() : renderDesktopFilterComponent()
    });
}
/* harmony default export */ var FilterComponent_FilterComponent = (FilterComponent);

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.styles.js

function FilterDrawer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    FilterDrawer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 56px;\n  border-bottom: 1px solid #eaeaea;\n  border-top: 1px solid #eaeaea;\n  @media screen and (max-width: ",
        "px) {\n    min-height: 56px;\n    z-index: 7;\n  }\n"
    ]);
    FilterDrawer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  font-size: 16px;\n  width: 100%;\n  margin-left: 16px;\n  align-items: center;\n"
    ]);
    FilterDrawer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  width: 124px;\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n"
    ]);
    FilterDrawer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n  height: calc(100vh - ",
        "px);\n  padding-bottom: 40px;\n  ",
        ";\n"
    ]);
    FilterDrawer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var FilterDrawerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterDrawerContainer",
    componentId: "sc-9a833bb7-0"
})(FilterDrawer_styles_templateObject());
var FilterHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterHeading",
    componentId: "sc-9a833bb7-1"
})(FilterDrawer_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var FilterHeadingText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterHeadingText",
    componentId: "sc-9a833bb7-2"
})(FilterDrawer_styles_templateObject2());
var ClearAllCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClearAllCta",
    componentId: "sc-9a833bb7-3"
})(FilterDrawer_styles_templateObject3(), (0,getThemeColor/* getThemeColor */.p)());
var FilterDrawerDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterDrawerDesktop",
    componentId: "sc-9a833bb7-4"
})(FilterDrawer_styles_templateObject4(), function(props) {
    return props === null || props === void 0 ? void 0 : props.headerHeight;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.loader) ? "pointer-events : none" : " ";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.js











function FilterDrawer(props) {
    var handleClearAll = /**
   * resets the filterOptions = [] and filtereditems = []
   * and filteredApplied counter goes to 0
   * reset payload api gets called again
   */ function handleClearAll() {
        dispatch((0,catalog/* filtersCounter */.Ds)(constants/* DEFAULT_FILTER_COUNT_VALUE */.Tv, true));
        if (typeId) {
            router.reload(router === null || router === void 0 ? void 0 : router.asPath);
            return;
        }
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: []
        };
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload));
    };
    var renderFilterDrawerHeading = function renderFilterDrawerHeading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterHeading, {
            ref: filterHeadingRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterHeadingText, {
                    children: "Filters"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClearAllCta, {
                    onClick: handleClearAll,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "pointer",
                            style: {
                                whiteSpace: "nowrap"
                            },
                            children: "Clear All"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: function(e) {
                                e.stopPropagation();
                                handleShowFilterDrawer();
                            },
                            className: "ml12px flex align-center pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconGrey/* CloseIconGrey */.U, {})
                        })
                    ]
                })
            ]
        });
    };
    var renderFilterDrawerDesktop = function renderFilterDrawerDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawerDesktop, {
            ref: filterDrawerRef,
            loader: filterOptionLoader,
            headerHeight: FilterDrawerTopMargin,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponent_FilterComponent, {
                hideCollectionFilter: props.hideCollectionFilter,
                hideCategoryFilter: props.hideCategoryFilter,
                hideTags: props.hideTags
            })
        });
    };
    var renderFilterDrawerMobile = function renderFilterDrawerMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponent_FilterComponent, {
            hideCollectionFilter: props.hideCollectionFilter,
            hideCategoryFilter: props.hideCategoryFilter
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var handleShowFilterDrawer = props.handleShowFilterDrawer;
    var filterDrawerRef = (0,react.useRef)();
    var filterHeadingRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), filterHeadingHeight = ref[0], setFilterHeadingHeight = ref[1];
    var ref1;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref2, ref3;
        return {
            headerHeight: (ref1 = (ref = state.commonReducer) === null || ref === void 0 ? void 0 : (ref2 = ref.headerRef) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.current) === null || ref3 === void 0 ? void 0 : ref3.clientHeight) !== null && ref1 !== void 0 ? ref1 : 0,
            sortType: state.catalogReducer.sortType,
            storeData: state.storeReducer.store,
            filterOptionLoader: state.commonReducer.filterOptionLoader
        };
    }), headerHeight = ref2.headerHeight, sortType = ref2.sortType, storeData = ref2.storeData, filterOptionLoader = ref2.filterOptionLoader;
    var typeId = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)().typeId;
    (0,react.useEffect)(function() {
        if (filterHeadingRef.current) {
            var ref;
            setFilterHeadingHeight((ref = filterHeadingRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!isMobile) {
            var styleOverflowHidden = function() {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            };
            var styleOverflowAuto = function() {
                document.getElementsByTagName("body")[0].style.overflowY = "auto";
            };
            if (filterDrawerRef.current) {
                var ref, ref1;
                (ref = filterDrawerRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("mouseover", styleOverflowHidden);
                (ref1 = filterDrawerRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("mouseout", styleOverflowAuto);
                return function() {
                    var ref, ref1;
                    (ref = filterDrawerRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("mouseover", styleOverflowHidden);
                    (ref1 = filterDrawerRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("mouseout", styleOverflowAuto);
                };
            }
        }
    }, []);
    var FilterDrawerTopMargin = headerHeight + filterHeadingHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterDrawerContainer, {
        children: [
            renderFilterDrawerHeading(),
            isMobile ? renderFilterDrawerMobile() : renderFilterDrawerDesktop()
        ]
    });
}
/* harmony default export */ var FilterDrawer_FilterDrawer = (FilterDrawer);


/***/ }),

/***/ 708710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ DEFAULT_GET_ITEMS_API_PAGE_SIZE; },
/* harmony export */   "FM": function() { return /* binding */ MB7_SORT_FILTER_TEMP_STORAGE_KEY; },
/* harmony export */   "Tr": function() { return /* binding */ getStoredMB7SortAndFilterConfig; },
/* harmony export */   "Wu": function() { return /* binding */ scrollIfItemPreviouslyClicked; },
/* harmony export */   "lr": function() { return /* binding */ setMB7SortAndFilterConfig; },
/* harmony export */   "vU": function() { return /* binding */ getPaginatedItemsPerPage; },
/* harmony export */   "ve": function() { return /* binding */ isCustomTag; }
/* harmony export */ });
/* unused harmony export MB7_SORT_FILTER_STORAGE_KEY */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(287243);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(644779);




var MB7_SORT_FILTER_STORAGE_KEY = "mb7SortAndFilterConfig";
var MB7_SORT_FILTER_TEMP_STORAGE_KEY = "mb7SortAndFilterConfigTemp";
var DEFAULT_GET_ITEMS_API_PAGE_SIZE = 20;
function scrollIfItemPreviouslyClicked() {
    var scrollConfig = (0,_utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__/* .scrollOnPageLoad */ .l)();
    if (scrollConfig.toScroll) {
        try {
            var y_scroll = scrollConfig.y_scroll;
            setTimeout(function() {
                sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
                window.scrollTo({
                    top: y_scroll
                });
            }, 300);
        } catch (err) {
            console.log("timeout time error:", err);
        }
    }
}
function getStoredMB7SortAndFilterConfig() {
    if (_utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY)) {
        return _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY);
    }
    return {
        filterAppliedCounter: 0,
        sortType: 0,
        collectionId: null,
        cid: null,
        isNextPage: true,
        pageNo: 1,
        filteredItems: [],
        filteredOptions: [],
        allowReset: true,
        filterAppliedCounterChanged: false,
        sortTypeChanged: false
    };
}
function setMB7SortAndFilterConfig(data) {
    var temp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var currentStoredData = getStoredMB7SortAndFilterConfig();
    var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, currentStoredData, data);
    if (temp) {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_TEMP_STORAGE_KEY, newData);
    } else {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_STORAGE_KEY, newData);
    }
}
function getPaginatedItemsPerPage() {
    var gridAndPaginationConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isMobile = arguments.length > 1 ? arguments[1] : void 0;
    var tmp = gridAndPaginationConfig.num_products_desktop, numProductsDesktop = tmp === void 0 ? DEFAULT_GET_ITEMS_API_PAGE_SIZE : tmp, tmp1 = gridAndPaginationConfig.num_products_mobile, numProductsMobile = tmp1 === void 0 ? DEFAULT_GET_ITEMS_API_PAGE_SIZE : tmp1;
    var value = isMobile ? numProductsMobile : numProductsDesktop;
    return value && !isNaN(Number(value)) ? Number(value) : DEFAULT_GET_ITEMS_API_PAGE_SIZE;
}
function isCustomTag(categoryData) {
    return (categoryData === null || categoryData === void 0 ? void 0 : categoryData.hasOwnProperty("is_custom_tag")) ? 1 : 0;
}


/***/ }),

/***/ 368464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(639996);



/***/ }),

/***/ 759240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomizedCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(999534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(690948);
/* harmony import */ var _mui_material_Checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169368);





// eslint-disable-next-line import/named

var BpIcon = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("span")(function(_param) {
    var theme = _param.theme, customRadius = _param.customRadius, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "theme",
        "customRadius"
    ]);
    return {
        borderRadius: customRadius !== undefined ? customRadius : 2,
        width: 16,
        height: 16,
        boxShadow: theme.palette.mode === "dark" ? "0 0 0 1px rgb(16 22 26 / 40%)" : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
        backgroundImage: theme.palette.mode === "dark" ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))" : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
        ".Mui-focusVisible &": {
            outline: "2px auto rgba(19,124,189,.6)",
            outlineOffset: 2
        },
        "input:disabled ~ &": {
            boxShadow: "none",
            background: theme.palette.mode === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)"
        }
    };
});
var BpCheckedIcon = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BpIcon)(function(_param) {
    var theme = _param.theme, selectedBackgroundColor = _param.selectedBackgroundColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "theme",
        "selectedBackgroundColor"
    ]);
    return {
        backgroundColor: selectedBackgroundColor ? selectedBackgroundColor : "#2B74D8",
        backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
        boxShadow: "none",
        "&::before": {
            display: "block",
            width: 16,
            height: 16,
            backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""'
        },
        "input:hover ~ &": {
            backgroundColor: selectedBackgroundColor ? selectedBackgroundColor : "#2B74D8"
        }
    };
});
// Inspired by blueprintjs
function BpCheckbox(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Checkbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        sx: {
            padding: 0,
            "&:hover": {
                bgcolor: "transparent"
            }
        },
        disableRipple: true,
        color: "default",
        style: {
            padding: 0,
            margin: 0
        },
        checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BpCheckedIcon, {
            selectedBackgroundColor: props.selectedBackgroundColor
        }),
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BpIcon, {
            customRadius: props.borderRadius
        }),
        inputProps: {
            "aria-label": "Checkbox demo"
        }
    }, props));
}
function CustomizedCheckbox(_param) {
    var checked = _param.checked, _handleChange = _param.handleChange, handleChange = _handleChange === void 0 ? undefined : _handleChange, className = _param.className, _style = _param.style, style = _style === void 0 ? {} : _style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "checked",
        "handleChange",
        "className",
        "style"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BpCheckbox, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        checked: checked,
        style: style,
        className: className,
        onChange: handleChange
    }, props));
}


/***/ }),

/***/ 698331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var src_hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(497429);



var FlatListV2 = function(param) {
    var children = param.children, loadMoreData = param.loadMoreData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var hasLoaded = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var isVisible = (0,src_hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref, {
        threshold: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isVisible && !hasLoaded.current) {
            loadMoreData();
            hasLoaded.current = true;
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FlatListV2);


/***/ }),

/***/ 130553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useGetTypeIdFromCanonicalDataStore; }
/* harmony export */ });
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268037);
/* harmony import */ var src_utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


var useGetTypeIdFromCanonicalDataStore = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref;
    var canonicalData = (0,src_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.catalogReducer.canonicalData;
    });
    return {
        typeId: +id || +(canonicalData === null || canonicalData === void 0 ? void 0 : (ref = canonicalData.item_group_details) === null || ref === void 0 ? void 0 : ref.id),
        isTypeCollection: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.COLLECTION */ .Rv.COLLECTION,
        isTypeCategory: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.CATEGORY */ .Rv.CATEGORY,
        isTypeTags: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.TAG */ .Rv.TAG
    };
};


/***/ }),

/***/ 497429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);


var useOnScreen = function(ref, options) {
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIntersecting = _$ref[0], setIntersecting = _$ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var current = ref.current;
        if (!current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            setIntersecting(entry.isIntersecting);
        }, options);
        observer.observe(current);
        return function() {
            if (current) observer.unobserve(current);
            observer.disconnect();
        };
    }, [
        ref,
        options
    ]);
    return isIntersecting;
};
/* harmony default export */ __webpack_exports__["Z"] = (useOnScreen);


/***/ }),

/***/ 302876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);




/**
 *
 * @param {*} ref reference to the div element whose height is checked from top
 * @param {*} generalConditon a set of condition that can overwrite the logic if true
 * @param {*} offsetTopHeight when element height distance is less than this value setstate triggers
 * @param {*} offsetBottomHeight when element height distance is less than this value setstate triggers
 * @returns {boolean} is element height is under offsetTopHeight or not
 */ function useTriggerChangeTopHeightMobile(ref, generalConditon, offsetTopHeight, offsetBottomHeight) {
    var checkifScrolledOffset = function checkifScrolledOffset() {
        var _$ref, _$ref1;
        if (((_$ref1 = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.getBoundingClientRect()) === null || _$ref1 === void 0 ? void 0 : _$ref1.top) <= offsetTopHeight) {
            var _$ref2, _$ref3;
            if (((_$ref3 = (_$ref2 = ref.current) === null || _$ref2 === void 0 ? void 0 : _$ref2.getBoundingClientRect()) === null || _$ref3 === void 0 ? void 0 : _$ref3.bottom) <= offsetBottomHeight) {
                setIsElementUnderOffset(false);
            } else setIsElementUnderOffset(true);
        } else setIsElementUnderOffset(false);
    };
    if (generalConditon) generalConditon;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isElementUnderOffset = ref1[0], setIsElementUnderOffset = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .MAX_MOBILE_WIDTH */ .Cf) window.addEventListener("scroll", checkifScrolledOffset);
        checkifScrolledOffset();
        return function() {
            window.removeEventListener("scroll", checkifScrolledOffset);
        };
    }, []);
    return isElementUnderOffset;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTriggerChangeTopHeightMobile);


/***/ }),

/***/ 542249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(225617);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96031);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(268037);




function useTriggerInitialFilterOptions() {
    var additionalCondition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var callInitialGetFilteredItemsOptions = function callInitialGetFilteredItemsOptions() {
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: []
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .getFilteredItemsOptions */ .OI)(payload));
    };
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var storeData = (0,_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return {
            sortType: state.catalogReducer.sortType,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter
        };
    }), sortType = ref.sortType, filterAppliedCounter = ref.filterAppliedCounter;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!filterAppliedCounter && (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && additionalCondition) {
            callInitialGetFilteredItemsOptions();
        }
    }, [
        filterAppliedCounter,
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        additionalCondition
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTriggerInitialFilterOptions);


/***/ }),

/***/ 936051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getFilteredOptionsProducts; }
/* harmony export */ });
/* harmony import */ var _components_DesignSystem_MiddleBody_MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(708710);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96031);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167261);



var getFilteredOptionsProducts = function(filterOptions) {
    var pageNo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, extraField = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        isMiddleBody7: false
    };
    var ref;
    var storeId = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().storeReducer.store.store_id;
    var sorting_type = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().catalogReducer) === null || ref === void 0 ? void 0 : ref.sortType;
    var dispatch = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dispatch */ .Z.dispatch;
    if (extraField === null || extraField === void 0 ? void 0 : extraField.isMiddleBody7) {
        var ref1;
        var isNextPage = (ref1 = (0,_components_DesignSystem_MiddleBody_MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_0__/* .getStoredMB7SortAndFilterConfig */ .Tr)()) === null || ref1 === void 0 ? void 0 : ref1.isNextPage;
        if (!isNextPage) {
            return {
                status: false,
                is_next_page: false
            };
        }
    }
    return new Promise(function(resolve, reject) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .getFilteredItemsOptions */ .OI)({
            store_id: storeId,
            page_no: pageNo,
            sorting_type: sorting_type,
            filters: filterOptions
        }, function(status, is_next_page) {
            return status ? resolve({
                status: status,
                is_next_page: is_next_page
            }) : reject(status);
        }));
    });
};


/***/ }),

/***/ 287243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ })

}]);